/**
 * NVRs migrated from tools/camera-additions.json (where they were
 * misclassified as cameras). Covers Hikvision DS-7600/7700/9600 + iDS-7700NXI
 * + iDS-9600NXI, Dahua NVR1000/2000-P/4000-4KS2/5000-EI/6000-4KL/IVSS,
 * Uniview NVR301/302/308/516, Hanwha XRN/QRN, Avigilon HD,
 * Tiandy TC-NR, Lorex/LTS long-tail.
 *
 * AUTO-GENERATED by tools/generate-migrated-catalogs.py from agent research
 * outputs in tools/equipment-research/. DO NOT edit by hand — re-run the
 * script if specs change. Generated on 2026-05-19.
 */
import type { EquipmentCatalogEntry } from './equipmentCatalogEntry';

export const MIGRATED_NVRS: EquipmentCatalogEntry[] = [
  {
    id: 'dahua-nvr5216-16p-ei',
    manufacturer: 'Dahua',
    model: 'NVR5216-16P-EI',
    category: 'nvr-recorder',
    tagline: 'NVR5216-16P-EI — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/2HDD/NVR5216-16P-EI',
    specs: {
      channels: 16,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5216-16p-i',
    manufacturer: 'Dahua',
    model: 'NVR5216-16P-I',
    category: 'nvr-recorder',
    tagline: 'NVR5216-16P-I — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/2HDD/NVR5216-16P-EI',
    specs: {
      channels: 16,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5216-8p-ei2',
    manufacturer: 'Dahua',
    model: 'NVR5216-8P-EI2',
    category: 'nvr-recorder',
    tagline: 'NVR5216-8P-EI2 — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/2HDD/NVR5216-16P-EI',
    specs: {
      channels: 16,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5216-16p-ei2',
    manufacturer: 'Dahua',
    model: 'NVR5216-16P-EI2',
    category: 'nvr-recorder',
    tagline: 'NVR5216-16P-EI2 — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/2HDD/NVR5216-16P-EI',
    specs: {
      channels: 16,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5216-16hp-ei2',
    manufacturer: 'Dahua',
    model: 'NVR5216-16HP-EI2',
    category: 'nvr-recorder',
    tagline: 'NVR5216-16HP-EI2 — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/2HDD/NVR5216-16P-EI',
    specs: {
      channels: 16,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5216-ei2',
    manufacturer: 'Dahua',
    model: 'NVR5216-EI2',
    category: 'nvr-recorder',
    tagline: 'NVR5216-EI2 — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/2HDD/NVR5216-16P-EI',
    specs: {
      channels: 16,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5216-ei',
    manufacturer: 'Dahua',
    model: 'NVR5216-EI',
    category: 'nvr-recorder',
    tagline: 'NVR5216-EI — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/2HDD/NVR5216-16P-EI',
    specs: {
      channels: 16,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5216-8p-ei',
    manufacturer: 'Dahua',
    model: 'NVR5216-8P-EI',
    category: 'nvr-recorder',
    tagline: 'NVR5216-8P-EI — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/2HDD/NVR5216-16P-EI',
    specs: {
      channels: 16,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5216-xi',
    manufacturer: 'Dahua',
    model: 'NVR5216-XI',
    category: 'nvr-recorder',
    tagline: 'NVR5216-XI — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/2HDD/NVR5216-16P-EI',
    specs: {
      channels: 16,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5216-16p-xi',
    manufacturer: 'Dahua',
    model: 'NVR5216-16P-XI',
    category: 'nvr-recorder',
    tagline: 'NVR5216-16P-XI — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/2HDD/NVR5216-16P-EI',
    specs: {
      channels: 16,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr2108-s3',
    manufacturer: 'Dahua',
    model: 'NVR2108-S3',
    category: 'nvr-recorder',
    tagline: 'NVR2108-S3 — 8-channel NVR, 1 HDD bay, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Network-Recorders/NVR2108-S3',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 100M',
    },
  },
  {
    id: 'dahua-nvr2108-8p-s3',
    manufacturer: 'Dahua',
    model: 'NVR2108-8P-S3',
    category: 'nvr-recorder',
    tagline: 'NVR2108-8P-S3 — 8-channel NVR, 1 HDD bay, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Network-Recorders/NVR2108-S3',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 100M',
    },
  },
  {
    id: 'dahua-nvr2108-8p-i2',
    manufacturer: 'Dahua',
    model: 'NVR2108-8P-I2',
    category: 'nvr-recorder',
    tagline: 'NVR2108-8P-I2 — 8-channel NVR, 1 HDD bay, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Network-Recorders/NVR2108-S3',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 100M',
    },
  },
  {
    id: 'dahua-nvr2108-i2',
    manufacturer: 'Dahua',
    model: 'NVR2108-I2',
    category: 'nvr-recorder',
    tagline: 'NVR2108-I2 — 8-channel NVR, 1 HDD bay, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Network-Recorders/NVR2108-S3',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 100M',
    },
  },
  {
    id: 'dahua-nvr2108-s3-0a',
    manufacturer: 'Dahua',
    model: 'NVR2108-S3%0A',
    category: 'nvr-recorder',
    tagline: 'NVR2108-S3%0A — 8-channel NVR, 1 HDD bay, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Network-Recorders/NVR2108-S3',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 100M',
    },
  },
  {
    id: 'dahua-nvr2108-4ks3',
    manufacturer: 'Dahua',
    model: 'NVR2108-4KS3',
    category: 'nvr-recorder',
    tagline: 'NVR2108-4KS3 — 8-channel NVR, 1 HDD bay, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Network-Recorders/NVR2108-S3',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 100M',
    },
  },
  {
    id: 'dahua-nvr2108-8p-i',
    manufacturer: 'Dahua',
    model: 'NVR2108-8P-I',
    category: 'nvr-recorder',
    tagline: 'NVR2108-8P-I — 8-channel NVR, 1 HDD bay, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Network-Recorders/NVR2108-S3',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 100M',
    },
  },
  {
    id: 'dahua-nvr4104-p-wt',
    manufacturer: 'Dahua',
    model: 'NVR4104-P-WT',
    category: 'nvr-recorder',
    tagline: 'NVR4104-P-WT — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/network-products/network-recorders/special-series/nvr4104-p-wt',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4104-p-4ks3',
    manufacturer: 'Dahua',
    model: 'NVR4104-P-4KS3',
    category: 'nvr-recorder',
    tagline: 'NVR4104-P-4KS3 — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/network-products/network-recorders/special-series/nvr4104-p-wt',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4104-4ks3',
    manufacturer: 'Dahua',
    model: 'NVR4104-4KS3',
    category: 'nvr-recorder',
    tagline: 'NVR4104-4KS3 — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/network-products/network-recorders/special-series/nvr4104-p-wt',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4104-wt',
    manufacturer: 'Dahua',
    model: 'NVR4104-WT',
    category: 'nvr-recorder',
    tagline: 'NVR4104-WT — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/network-products/network-recorders/special-series/nvr4104-p-wt',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4104-4ks3-0a',
    manufacturer: 'Dahua',
    model: 'NVR4104-4KS3%0A',
    category: 'nvr-recorder',
    tagline: 'NVR4104-4KS3%0A — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/network-products/network-recorders/special-series/nvr4104-p-wt',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4104-p-4ks2l',
    manufacturer: 'Dahua',
    model: 'NVR4104-P-4KS2L',
    category: 'nvr-recorder',
    tagline: 'NVR4104-P-4KS2L — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/network-products/network-recorders/special-series/nvr4104-p-wt',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4104-p-4ks3-960g-ssd',
    manufacturer: 'Dahua',
    model: 'NVR4104-P-4KS3(960G)=SSD',
    category: 'nvr-recorder',
    tagline: 'NVR4104-P-4KS3(960G)=SSD — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/network-products/network-recorders/special-series/nvr4104-p-wt',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4104-ei',
    manufacturer: 'Dahua',
    model: 'NVR4104-EI',
    category: 'nvr-recorder',
    tagline: 'NVR4104-EI — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/network-products/network-recorders/special-series/nvr4104-p-wt',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4104-p-ei',
    manufacturer: 'Dahua',
    model: 'NVR4104-P-EI',
    category: 'nvr-recorder',
    tagline: 'NVR4104-P-EI — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/network-products/network-recorders/special-series/nvr4104-p-wt',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5232-2n-ei2',
    manufacturer: 'Dahua',
    model: 'NVR5232-2N-EI2',
    category: 'nvr-recorder',
    tagline: 'NVR5232-2N-EI2 — 32-channel NVR, 2 HDD bays, 16-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI2-Series/2HDD/NVR5232-2N-EI2',
    specs: {
      channels: 32,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5232-8p-ei2',
    manufacturer: 'Dahua',
    model: 'NVR5232-8P-EI2',
    category: 'nvr-recorder',
    tagline: 'NVR5232-8P-EI2 — 32-channel NVR, 2 HDD bays, 16-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI2-Series/2HDD/NVR5232-2N-EI2',
    specs: {
      channels: 32,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5232-ei2',
    manufacturer: 'Dahua',
    model: 'NVR5232-EI2',
    category: 'nvr-recorder',
    tagline: 'NVR5232-EI2 — 32-channel NVR, 2 HDD bays, 16-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI2-Series/2HDD/NVR5232-2N-EI2',
    specs: {
      channels: 32,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5232-16p-ei2',
    manufacturer: 'Dahua',
    model: 'NVR5232-16P-EI2',
    category: 'nvr-recorder',
    tagline: 'NVR5232-16P-EI2 — 32-channel NVR, 2 HDD bays, 16-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI2-Series/2HDD/NVR5232-2N-EI2',
    specs: {
      channels: 32,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5232-ei',
    manufacturer: 'Dahua',
    model: 'NVR5232-EI',
    category: 'nvr-recorder',
    tagline: 'NVR5232-EI — 32-channel NVR, 2 HDD bays, 16-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI2-Series/2HDD/NVR5232-2N-EI2',
    specs: {
      channels: 32,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5232-16p-ei',
    manufacturer: 'Dahua',
    model: 'NVR5232-16P-EI',
    category: 'nvr-recorder',
    tagline: 'NVR5232-16P-EI — 32-channel NVR, 2 HDD bays, 16-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI2-Series/2HDD/NVR5232-2N-EI2',
    specs: {
      channels: 32,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5232-8p-ei',
    manufacturer: 'Dahua',
    model: 'NVR5232-8P-EI',
    category: 'nvr-recorder',
    tagline: 'NVR5232-8P-EI — 32-channel NVR, 2 HDD bays, 16-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI2-Series/2HDD/NVR5232-2N-EI2',
    specs: {
      channels: 32,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5232-ei-0a',
    manufacturer: 'Dahua',
    model: 'NVR5232-EI%0A',
    category: 'nvr-recorder',
    tagline: 'NVR5232-EI%0A — 32-channel NVR, 2 HDD bays, 16-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI2-Series/2HDD/NVR5232-2N-EI2',
    specs: {
      channels: 32,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr2104-p-s3',
    manufacturer: 'Dahua',
    model: 'NVR2104-P-S3',
    category: 'nvr-recorder',
    tagline: 'NVR2104-P-S3 — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Network-Recorders/NVR2104-P-S3',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 100M',
    },
  },
  {
    id: 'dahua-nvr2104-s3',
    manufacturer: 'Dahua',
    model: 'NVR2104-S3',
    category: 'nvr-recorder',
    tagline: 'NVR2104-S3 — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Network-Recorders/NVR2104-P-S3',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 100M',
    },
  },
  {
    id: 'dahua-nvr2104-p-i2',
    manufacturer: 'Dahua',
    model: 'NVR2104-P-I2',
    category: 'nvr-recorder',
    tagline: 'NVR2104-P-I2 — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Network-Recorders/NVR2104-P-S3',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 100M',
    },
  },
  {
    id: 'dahua-nvr2104-i2',
    manufacturer: 'Dahua',
    model: 'NVR2104-I2',
    category: 'nvr-recorder',
    tagline: 'NVR2104-I2 — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Network-Recorders/NVR2104-P-S3',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 100M',
    },
  },
  {
    id: 'dahua-nvr2104-p-4ks2-0a',
    manufacturer: 'Dahua',
    model: 'NVR2104-P-4KS2%0A',
    category: 'nvr-recorder',
    tagline: 'NVR2104-P-4KS2%0A — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Network-Recorders/NVR2104-P-S3',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 100M',
    },
  },
  {
    id: 'dahua-nvr2104-p-i',
    manufacturer: 'Dahua',
    model: 'NVR2104-P-I',
    category: 'nvr-recorder',
    tagline: 'NVR2104-P-I — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/Network-Recorders/NVR2104-P-S3',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 100M',
    },
  },
  {
    id: 'dahua-nvr4108-wt',
    manufacturer: 'Dahua',
    model: 'NVR4108-WT',
    category: 'nvr-recorder',
    tagline: 'NVR4108-WT — 8-channel NVR, 1 HDD bay, 8-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/network-products/network-recorders/special-series/nvr4108-wt',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 8,
      poeBudgetW: 80,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4108-8p-4ks3',
    manufacturer: 'Dahua',
    model: 'NVR4108-8P-4KS3',
    category: 'nvr-recorder',
    tagline: 'NVR4108-8P-4KS3 — 8-channel NVR, 1 HDD bay, 8-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/network-products/network-recorders/special-series/nvr4108-wt',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 8,
      poeBudgetW: 80,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4108-p-4ks3',
    manufacturer: 'Dahua',
    model: 'NVR4108-P-4KS3',
    category: 'nvr-recorder',
    tagline: 'NVR4108-P-4KS3 — 8-channel NVR, 1 HDD bay, 8-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/network-products/network-recorders/special-series/nvr4108-wt',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 8,
      poeBudgetW: 80,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4108-4ks3',
    manufacturer: 'Dahua',
    model: 'NVR4108-4KS3',
    category: 'nvr-recorder',
    tagline: 'NVR4108-4KS3 — 8-channel NVR, 1 HDD bay, 8-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/network-products/network-recorders/special-series/nvr4108-wt',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 8,
      poeBudgetW: 80,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4108-8p-ei',
    manufacturer: 'Dahua',
    model: 'NVR4108-8P-EI',
    category: 'nvr-recorder',
    tagline: 'NVR4108-8P-EI — 8-channel NVR, 1 HDD bay, 8-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/network-products/network-recorders/special-series/nvr4108-wt',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 8,
      poeBudgetW: 80,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4108-ei',
    manufacturer: 'Dahua',
    model: 'NVR4108-EI',
    category: 'nvr-recorder',
    tagline: 'NVR4108-EI — 8-channel NVR, 1 HDD bay, 8-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/network-products/network-recorders/special-series/nvr4108-wt',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 8,
      poeBudgetW: 80,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4108-p-ei',
    manufacturer: 'Dahua',
    model: 'NVR4108-P-EI',
    category: 'nvr-recorder',
    tagline: 'NVR4108-P-EI — 8-channel NVR, 1 HDD bay, 8-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/network-products/network-recorders/special-series/nvr4108-wt',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 8,
      poeBudgetW: 80,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5432-16p-ei',
    manufacturer: 'Dahua',
    model: 'NVR5432-16P-EI',
    category: 'nvr-recorder',
    tagline: 'NVR5432-16P-EI — 32-channel NVR, 4 HDD bays, 16-port built-in PoE, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/4HDD/NVR5432-16P-EI',
    specs: {
      channels: 32,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5432-16hp-ei2',
    manufacturer: 'Dahua',
    model: 'NVR5432-16HP-EI2',
    category: 'nvr-recorder',
    tagline: 'NVR5432-16HP-EI2 — 32-channel NVR, 4 HDD bays, 16-port built-in PoE, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/4HDD/NVR5432-16P-EI',
    specs: {
      channels: 32,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5432-16p-xi',
    manufacturer: 'Dahua',
    model: 'NVR5432-16P-XI',
    category: 'nvr-recorder',
    tagline: 'NVR5432-16P-XI — 32-channel NVR, 4 HDD bays, 16-port built-in PoE, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/4HDD/NVR5432-16P-EI',
    specs: {
      channels: 32,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5432-16p-i',
    manufacturer: 'Dahua',
    model: 'NVR5432-16P-I',
    category: 'nvr-recorder',
    tagline: 'NVR5432-16P-I — 32-channel NVR, 4 HDD bays, 16-port built-in PoE, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/4HDD/NVR5432-16P-EI',
    specs: {
      channels: 32,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5432-xi',
    manufacturer: 'Dahua',
    model: 'NVR5432-XI',
    category: 'nvr-recorder',
    tagline: 'NVR5432-XI — 32-channel NVR, 4 HDD bays, 16-port built-in PoE, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/4HDD/NVR5432-16P-EI',
    specs: {
      channels: 32,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5432-ei',
    manufacturer: 'Dahua',
    model: 'NVR5432-EI',
    category: 'nvr-recorder',
    tagline: 'NVR5432-EI — 32-channel NVR, 4 HDD bays, 16-port built-in PoE, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/4HDD/NVR5432-16P-EI',
    specs: {
      channels: 32,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5208-ei2',
    manufacturer: 'Dahua',
    model: 'NVR5208-EI2',
    category: 'nvr-recorder',
    tagline: 'NVR5208-EI2 — 8-channel NVR, 2 HDD bays, 8-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI2-Series/2HDD/NVR5208-EI2',
    specs: {
      channels: 8,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 8,
      poeBudgetW: 130,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5208-8p-ei2',
    manufacturer: 'Dahua',
    model: 'NVR5208-8P-EI2',
    category: 'nvr-recorder',
    tagline: 'NVR5208-8P-EI2 — 8-channel NVR, 2 HDD bays, 8-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI2-Series/2HDD/NVR5208-EI2',
    specs: {
      channels: 8,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 8,
      poeBudgetW: 130,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5208-8p-ei',
    manufacturer: 'Dahua',
    model: 'NVR5208-8P-EI',
    category: 'nvr-recorder',
    tagline: 'NVR5208-8P-EI — 8-channel NVR, 2 HDD bays, 8-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI2-Series/2HDD/NVR5208-EI2',
    specs: {
      channels: 8,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 8,
      poeBudgetW: 130,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5208-ei',
    manufacturer: 'Dahua',
    model: 'NVR5208-EI',
    category: 'nvr-recorder',
    tagline: 'NVR5208-EI — 8-channel NVR, 2 HDD bays, 8-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI2-Series/2HDD/NVR5208-EI2',
    specs: {
      channels: 8,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 8,
      poeBudgetW: 130,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5208-8p-xi',
    manufacturer: 'Dahua',
    model: 'NVR5208-8P-XI',
    category: 'nvr-recorder',
    tagline: 'NVR5208-8P-XI — 8-channel NVR, 2 HDD bays, 8-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI2-Series/2HDD/NVR5208-EI2',
    specs: {
      channels: 8,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 8,
      poeBudgetW: 130,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5208-xi',
    manufacturer: 'Dahua',
    model: 'NVR5208-XI',
    category: 'nvr-recorder',
    tagline: 'NVR5208-XI — 8-channel NVR, 2 HDD bays, 8-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI2-Series/2HDD/NVR5208-EI2',
    specs: {
      channels: 8,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 2,
      hddBayMaxTb: 20,
      poeInPorts: 8,
      poeBudgetW: 130,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4208-8p-ei',
    manufacturer: 'Dahua',
    model: 'NVR4208-8P-EI',
    category: 'nvr-recorder',
    tagline: 'NVR4208-8P-EI — 8-channel NVR, 2 HDD bays, 8-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/la/products/All-Products/Discontinued-Products/Network-Recorders/NVR4208-8P-I',
    specs: {
      channels: 8,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      poeInPorts: 8,
      poeBudgetW: 130,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4208-8p-4ks2',
    manufacturer: 'Dahua',
    model: 'NVR4208-8P-4KS2',
    category: 'nvr-recorder',
    tagline: 'NVR4208-8P-4KS2 — 8-channel NVR, 2 HDD bays, 8-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/la/products/All-Products/Discontinued-Products/Network-Recorders/NVR4208-8P-I',
    specs: {
      channels: 8,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      poeInPorts: 8,
      poeBudgetW: 130,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4208-4ks3',
    manufacturer: 'Dahua',
    model: 'NVR4208-4KS3',
    category: 'nvr-recorder',
    tagline: 'NVR4208-4KS3 — 8-channel NVR, 2 HDD bays, 8-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/la/products/All-Products/Discontinued-Products/Network-Recorders/NVR4208-8P-I',
    specs: {
      channels: 8,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      poeInPorts: 8,
      poeBudgetW: 130,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4208-8p-4ks3',
    manufacturer: 'Dahua',
    model: 'NVR4208-8P-4KS3',
    category: 'nvr-recorder',
    tagline: 'NVR4208-8P-4KS3 — 8-channel NVR, 2 HDD bays, 8-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/la/products/All-Products/Discontinued-Products/Network-Recorders/NVR4208-8P-I',
    specs: {
      channels: 8,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      poeInPorts: 8,
      poeBudgetW: 130,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4208-ei',
    manufacturer: 'Dahua',
    model: 'NVR4208-EI',
    category: 'nvr-recorder',
    tagline: 'NVR4208-EI — 8-channel NVR, 2 HDD bays, 8-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/la/products/All-Products/Discontinued-Products/Network-Recorders/NVR4208-8P-I',
    specs: {
      channels: 8,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      poeInPorts: 8,
      poeBudgetW: 130,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4216-i',
    manufacturer: 'Dahua',
    model: 'NVR4216-I',
    category: 'nvr-recorder',
    tagline: 'NVR4216-I — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/la/products/All-Products/Discontinued-Products/Network-Recorders/NVR4216-I',
    specs: {
      channels: 16,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4216-16p-i',
    manufacturer: 'Dahua',
    model: 'NVR4216-16P-I',
    category: 'nvr-recorder',
    tagline: 'NVR4216-16P-I — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/la/products/All-Products/Discontinued-Products/Network-Recorders/NVR4216-I',
    specs: {
      channels: 16,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4216-16p-4ks3',
    manufacturer: 'Dahua',
    model: 'NVR4216-16P-4KS3',
    category: 'nvr-recorder',
    tagline: 'NVR4216-16P-4KS3 — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/la/products/All-Products/Discontinued-Products/Network-Recorders/NVR4216-I',
    specs: {
      channels: 16,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4216-16p-ei',
    manufacturer: 'Dahua',
    model: 'NVR4216-16P-EI',
    category: 'nvr-recorder',
    tagline: 'NVR4216-16P-EI — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/la/products/All-Products/Discontinued-Products/Network-Recorders/NVR4216-I',
    specs: {
      channels: 16,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4216-4ks3',
    manufacturer: 'Dahua',
    model: 'NVR4216-4KS3',
    category: 'nvr-recorder',
    tagline: 'NVR4216-4KS3 — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/la/products/All-Products/Discontinued-Products/Network-Recorders/NVR4216-I',
    specs: {
      channels: 16,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4216-ei',
    manufacturer: 'Dahua',
    model: 'NVR4216-EI',
    category: 'nvr-recorder',
    tagline: 'NVR4216-EI — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/la/products/All-Products/Discontinued-Products/Network-Recorders/NVR4216-I',
    specs: {
      channels: 16,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4116-wt',
    manufacturer: 'Dahua',
    model: 'NVR4116-WT',
    category: 'nvr-recorder',
    tagline: 'NVR4116-WT — 16-channel NVR, 1 HDD bay, 8-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/network-products/network-recorders/special-series/nvr4116-wt',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 8,
      poeBudgetW: 100,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4116-8p-4ks3',
    manufacturer: 'Dahua',
    model: 'NVR4116-8P-4KS3',
    category: 'nvr-recorder',
    tagline: 'NVR4116-8P-4KS3 — 16-channel NVR, 1 HDD bay, 8-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/network-products/network-recorders/special-series/nvr4116-wt',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 8,
      poeBudgetW: 100,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4116-4ks3',
    manufacturer: 'Dahua',
    model: 'NVR4116-4KS3',
    category: 'nvr-recorder',
    tagline: 'NVR4116-4KS3 — 16-channel NVR, 1 HDD bay, 8-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/network-products/network-recorders/special-series/nvr4116-wt',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 8,
      poeBudgetW: 100,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4116-8p-ei',
    manufacturer: 'Dahua',
    model: 'NVR4116-8P-EI',
    category: 'nvr-recorder',
    tagline: 'NVR4116-8P-EI — 16-channel NVR, 1 HDD bay, 8-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/network-products/network-recorders/special-series/nvr4116-wt',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 8,
      poeBudgetW: 100,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4116-ei',
    manufacturer: 'Dahua',
    model: 'NVR4116-EI',
    category: 'nvr-recorder',
    tagline: 'NVR4116-EI — 16-channel NVR, 1 HDD bay, 8-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/network-products/network-recorders/special-series/nvr4116-wt',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 8,
      poeBudgetW: 100,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr2116-s3',
    manufacturer: 'Dahua',
    model: 'NVR2116-S3',
    category: 'nvr-recorder',
    tagline: 'NVR2116-S3 — 16-channel NVR, 1 HDD bay, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Network-Recorders/NVR2116-I',
    specs: {
      channels: 16,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 100M',
    },
  },
  {
    id: 'dahua-nvr2116-i2',
    manufacturer: 'Dahua',
    model: 'NVR2116-I2',
    category: 'nvr-recorder',
    tagline: 'NVR2116-I2 — 16-channel NVR, 1 HDD bay, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Network-Recorders/NVR2116-I',
    specs: {
      channels: 16,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 100M',
    },
  },
  {
    id: 'dahua-nvr2116-s3-0a',
    manufacturer: 'Dahua',
    model: 'NVR2116-S3%0A',
    category: 'nvr-recorder',
    tagline: 'NVR2116-S3%0A — 16-channel NVR, 1 HDD bay, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Network-Recorders/NVR2116-I',
    specs: {
      channels: 16,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 100M',
    },
  },
  {
    id: 'dahua-nvr2204-p-i',
    manufacturer: 'Dahua',
    model: 'NVR2204-P-I',
    category: 'nvr-recorder',
    tagline: 'NVR2204-P-I — 4-channel NVR, 2 HDD bays, 4-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Network-Recorders/NVR2204-P-I',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 100M',
    },
  },
  {
    id: 'dahua-nvr2204-p-4ks2',
    manufacturer: 'Dahua',
    model: 'NVR2204-P-4KS2',
    category: 'nvr-recorder',
    tagline: 'NVR2204-P-4KS2 — 4-channel NVR, 2 HDD bays, 4-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Network-Recorders/NVR2204-P-I',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 100M',
    },
  },
  {
    id: 'dahua-nvr2208-i',
    manufacturer: 'Dahua',
    model: 'NVR2208-I',
    category: 'nvr-recorder',
    tagline: 'NVR2208-I — 8-channel NVR, 2 HDD bays, 8-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Network-Recorders/NVR2208-I',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      poeInPorts: 8,
      poeBudgetW: 130,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr2208-8p-i',
    manufacturer: 'Dahua',
    model: 'NVR2208-8P-I',
    category: 'nvr-recorder',
    tagline: 'NVR2208-8P-I — 8-channel NVR, 2 HDD bays, 8-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Network-Recorders/NVR2208-I',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      poeInPorts: 8,
      poeBudgetW: 130,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr2208-8p-4ks2',
    manufacturer: 'Dahua',
    model: 'NVR2208-8P-4KS2',
    category: 'nvr-recorder',
    tagline: 'NVR2208-8P-4KS2 — 8-channel NVR, 2 HDD bays, 8-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Network-Recorders/NVR2208-I',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      poeInPorts: 8,
      poeBudgetW: 130,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr2216-16p-i',
    manufacturer: 'Dahua',
    model: 'NVR2216-16P-I',
    category: 'nvr-recorder',
    tagline: 'NVR2216-16P-I — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Network-Recorders/NVR2216-I',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr2216-16p-i2',
    manufacturer: 'Dahua',
    model: 'NVR2216-16P-I2',
    category: 'nvr-recorder',
    tagline: 'NVR2216-16P-I2 — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Network-Recorders/NVR2216-I',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr2216-i2',
    manufacturer: 'Dahua',
    model: 'NVR2216-I2',
    category: 'nvr-recorder',
    tagline: 'NVR2216-I2 — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/Network-Recorders/NVR2216-I',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5816-32-64-r-16p-4ks2e',
    manufacturer: 'Dahua',
    model: 'NVR5816-32-64-R-16P-4KS2E',
    category: 'nvr-recorder',
    tagline: 'NVR5816-32-64-R-16P-4KS2E — 64-channel NVR, 8 HDD bays, 16-port built-in PoE, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Network-Recorders/Pro-Series/NVR5-Series/8HDD/NVR5816-32-64-R-16P-4KS2E',
    specs: {
      channels: 64,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5816-32-64-r-4ks2',
    manufacturer: 'Dahua',
    model: 'NVR5816-32-64-R-4KS2',
    category: 'nvr-recorder',
    tagline: 'NVR5816-32-64-R-4KS2 — 64-channel NVR, 8 HDD bays, 16-port built-in PoE, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Network-Recorders/Pro-Series/NVR5-Series/8HDD/NVR5816-32-64-R-16P-4KS2E',
    specs: {
      channels: 64,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5816-16p-ei',
    manufacturer: 'Dahua',
    model: 'NVR5816-16P-EI',
    category: 'nvr-recorder',
    tagline: 'NVR5816-16P-EI — 64-channel NVR, 8 HDD bays, 16-port built-in PoE, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Network-Recorders/Pro-Series/NVR5-Series/8HDD/NVR5816-32-64-R-16P-4KS2E',
    specs: {
      channels: 64,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5816-ei',
    manufacturer: 'Dahua',
    model: 'NVR5816-EI',
    category: 'nvr-recorder',
    tagline: 'NVR5816-EI — 64-channel NVR, 8 HDD bays, 16-port built-in PoE, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Network-Recorders/Pro-Series/NVR5-Series/8HDD/NVR5816-32-64-R-16P-4KS2E',
    specs: {
      channels: 64,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5416-16p-xi',
    manufacturer: 'Dahua',
    model: 'NVR5416-16P-XI',
    category: 'nvr-recorder',
    tagline: 'NVR5416-16P-XI — 16-channel NVR, 4 HDD bays, 16-port built-in PoE, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Network-Recorders/WizMind-Series/NVR5-XI/4HDD/NVR5416-16P-XI',
    specs: {
      channels: 16,
      inputBandwidthMbps: 512,
      outputBandwidthMbps: 512,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5416-xi',
    manufacturer: 'Dahua',
    model: 'NVR5416-XI',
    category: 'nvr-recorder',
    tagline: 'NVR5416-XI — 16-channel NVR, 4 HDD bays, 16-port built-in PoE, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Network-Recorders/WizMind-Series/NVR5-XI/4HDD/NVR5416-16P-XI',
    specs: {
      channels: 16,
      inputBandwidthMbps: 512,
      outputBandwidthMbps: 512,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5416-16p-ei',
    manufacturer: 'Dahua',
    model: 'NVR5416-16P-EI',
    category: 'nvr-recorder',
    tagline: 'NVR5416-16P-EI — 16-channel NVR, 4 HDD bays, 16-port built-in PoE, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Network-Recorders/WizMind-Series/NVR5-XI/4HDD/NVR5416-16P-XI',
    specs: {
      channels: 16,
      inputBandwidthMbps: 512,
      outputBandwidthMbps: 512,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5416-ei',
    manufacturer: 'Dahua',
    model: 'NVR5416-EI',
    category: 'nvr-recorder',
    tagline: 'NVR5416-EI — 16-channel NVR, 4 HDD bays, 16-port built-in PoE, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/br/products/All-Products/Network-Recorders/WizMind-Series/NVR5-XI/4HDD/NVR5416-16P-XI',
    specs: {
      channels: 16,
      inputBandwidthMbps: 512,
      outputBandwidthMbps: 512,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5464-16p-ei',
    manufacturer: 'Dahua',
    model: 'NVR5464-16P-EI',
    category: 'nvr-recorder',
    tagline: 'NVR5464-16P-EI — 64-channel NVR, 4 HDD bays, 16-port built-in PoE, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/4HDD/NVR5464-16P-EI',
    specs: {
      channels: 64,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5464-ei',
    manufacturer: 'Dahua',
    model: 'NVR5464-EI',
    category: 'nvr-recorder',
    tagline: 'NVR5464-EI — 64-channel NVR, 4 HDD bays, 16-port built-in PoE, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/4HDD/NVR5464-16P-EI',
    specs: {
      channels: 64,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5464-ei-0a',
    manufacturer: 'Dahua',
    model: 'NVR5464-EI%0A',
    category: 'nvr-recorder',
    tagline: 'NVR5464-EI%0A — 64-channel NVR, 4 HDD bays, 16-port built-in PoE, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/4HDD/NVR5464-16P-EI',
    specs: {
      channels: 64,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5464-ei-0a-0a-d0-a8-d1-83-d0-bd-d0-b8',
    manufacturer: 'Dahua',
    model: 'NVR5464-EI%0A%0A%D0%A8%D1%83%D0%BD%D0%B8',
    category: 'nvr-recorder',
    tagline: 'NVR5464-EI%0A%0A%D0%A8%D1%83%D0%BD%D0%B8 — 64-channel NVR, 4 HDD bays, 16-port built-in PoE, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/4HDD/NVR5464-16P-EI',
    specs: {
      channels: 64,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr616-64-128-4ks2',
    manufacturer: 'Dahua',
    model: 'NVR616-64-128-4KS2',
    category: 'nvr-recorder',
    tagline: 'NVR616-64-128-4KS2 — 128-channel NVR, 16 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Network-Recorders/Ultra-Series/NVR6-Series/16HDD/NVR616-64-128-4KS2',
    specs: {
      channels: 128,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '12 MP',
      hddBays: 16,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '3U',
      alarmIO: '16-in / 8-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr616-64128-4ks2',
    manufacturer: 'Dahua',
    model: 'NVR616-64128-4KS2',
    category: 'nvr-recorder',
    tagline: 'NVR616-64128-4KS2 — 128-channel NVR, 16 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Network-Recorders/Ultra-Series/NVR6-Series/16HDD/NVR616-64-128-4KS2',
    specs: {
      channels: 128,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '12 MP',
      hddBays: 16,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '3U',
      alarmIO: '16-in / 8-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr608-128-4ks2',
    manufacturer: 'Dahua',
    model: 'NVR608-128-4KS2',
    category: 'nvr-recorder',
    tagline: 'NVR608-128-4KS2 — 128-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/ea/products/All-Products/Network-Recorders/Ultra-Series/8HDD/NVR608-128-4KS2',
    specs: {
      channels: 128,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 8-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr608-32-4ks2',
    manufacturer: 'Dahua',
    model: 'NVR608-32-4KS2',
    category: 'nvr-recorder',
    tagline: 'NVR608-32-4KS2 — 128-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/ea/products/All-Products/Network-Recorders/Ultra-Series/8HDD/NVR608-128-4KS2',
    specs: {
      channels: 128,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 8-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvrd04-32-5e',
    manufacturer: 'Dahua',
    model: 'NVRD04-32-5E',
    category: 'nvr-recorder',
    tagline: 'NVRD04-32-5E — 32-channel NVR, 4 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/tr/products/All-Products/Network-Recorders/WizSense-Series/NVRD04-32-5E',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '12 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvrd04-16-5e',
    manufacturer: 'Dahua',
    model: 'NVRD04-16-5E',
    category: 'nvr-recorder',
    tagline: 'NVRD04-16-5E — 32-channel NVR, 4 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/tr/products/All-Products/Network-Recorders/WizSense-Series/NVRD04-32-5E',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '12 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5424-24p-ei',
    manufacturer: 'Dahua',
    model: 'NVR5424-24P-EI',
    category: 'nvr-recorder',
    tagline: 'NVR5424-24P-EI — 24-channel NVR, 4 HDD bays, 24-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/4HDD/NVR5424-24P-EI',
    specs: {
      channels: 24,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 20,
      poeInPorts: 24,
      poeBudgetW: 300,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5424-24p-4ks2',
    manufacturer: 'Dahua',
    model: 'NVR5424-24P-4KS2',
    category: 'nvr-recorder',
    tagline: 'NVR5424-24P-4KS2 — 24-channel NVR, 4 HDD bays, 24-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/4HDD/NVR5424-24P-EI',
    specs: {
      channels: 24,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 20,
      poeInPorts: 24,
      poeBudgetW: 300,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5864-16p-ei',
    manufacturer: 'Dahua',
    model: 'NVR5864-16P-EI',
    category: 'nvr-recorder',
    tagline: 'NVR5864-16P-EI — 64-channel NVR, 8 HDD bays, 16-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/8HDD/NVR5864-16P-EI',
    specs: {
      channels: 64,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 8,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5864-ei',
    manufacturer: 'Dahua',
    model: 'NVR5864-EI',
    category: 'nvr-recorder',
    tagline: 'NVR5864-EI — 64-channel NVR, 8 HDD bays, 16-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/8HDD/NVR5864-16P-EI',
    specs: {
      channels: 64,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 8,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5832-ei',
    manufacturer: 'Dahua',
    model: 'NVR5832-EI',
    category: 'nvr-recorder',
    tagline: 'NVR5832-EI — 32-channel NVR, 8 HDD bays, 16-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/8HDD/NVR5832-EI',
    specs: {
      channels: 32,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 8,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr5832-16p-ei',
    manufacturer: 'Dahua',
    model: 'NVR5832-16P-EI',
    category: 'nvr-recorder',
    tagline: 'NVR5832-16P-EI — 32-channel NVR, 8 HDD bays, 16-port built-in PoE, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/uk/products/All-Products/Network-Recorders/WizSense-Series/NVR-5-EI-Series/8HDD/NVR5832-EI',
    specs: {
      channels: 32,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 8,
      hddBayMaxTb: 20,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4232-4ks3',
    manufacturer: 'Dahua',
    model: 'NVR4232-4KS3',
    category: 'nvr-recorder',
    tagline: 'NVR4232-4KS3 — 32-channel NVR, 2 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/Pro-Series/NVR-4KS3/NVR4232-4KS3',
    specs: {
      channels: 32,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'dahua-nvr4232-ei',
    manufacturer: 'Dahua',
    model: 'NVR4232-EI',
    category: 'nvr-recorder',
    tagline: 'NVR4232-EI — 32-channel NVR, 2 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Network-Recorders/Pro-Series/NVR-4KS3/NVR4232-4KS3',
    specs: {
      channels: 32,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 320,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['Smart 265', 'H.265+', 'H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'hikvision-ds-7732nxi-i4-vpro',
    manufacturer: 'Hikvision',
    model: 'DS-7732NXI-I4-VPRO',
    category: 'nvr-recorder',
    tagline: 'DS-7732NXI-I4-VPRO — 32-channel NVR, 4 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hikvision.com/en/products/IP-Products/Network-Video-Recorders/Pro-Series/DS-7732NXI-I4-S/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hikvision-ds-7732nxi-i4-s',
    manufacturer: 'Hikvision',
    model: 'DS-7732NXI-I4-S',
    category: 'nvr-recorder',
    tagline: 'DS-7732NXI-I4-S — 32-channel NVR, 4 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hikvision.com/en/products/IP-Products/Network-Video-Recorders/Pro-Series/DS-7732NXI-I4-S/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hikvision-ds-7732nxi-i4-vpro-msm-moved',
    manufacturer: 'Hikvision',
    model: 'DS-7732NXI-I4-VPRO_MSM_MOVED',
    category: 'nvr-recorder',
    tagline: 'DS-7732NXI-I4-VPRO_MSM_MOVED — 32-channel NVR, 4 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hikvision.com/en/products/IP-Products/Network-Video-Recorders/Pro-Series/DS-7732NXI-I4-S/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hikvision-ds-7732nxi-i4-4s',
    manufacturer: 'Hikvision',
    model: 'DS-7732NXI-I4-4S',
    category: 'nvr-recorder',
    tagline: 'DS-7732NXI-I4-4S — 32-channel NVR, 4 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hikvision.com/en/products/IP-Products/Network-Video-Recorders/Pro-Series/DS-7732NXI-I4-S/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hikvision-ds-7732nxi-i4-s-e-pl',
    manufacturer: 'Hikvision',
    model: 'DS-7732NXI-I4-S-E-PL',
    category: 'nvr-recorder',
    tagline: 'DS-7732NXI-I4-S-E-PL — 32-channel NVR, 4 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hikvision.com/en/products/IP-Products/Network-Video-Recorders/Pro-Series/DS-7732NXI-I4-S/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hikvision-ds-7732nxi-i4-s-brasil',
    manufacturer: 'Hikvision',
    model: 'DS-7732NXI-I4-S-BRASIL',
    category: 'nvr-recorder',
    tagline: 'DS-7732NXI-I4-S-BRASIL — 32-channel NVR, 4 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hikvision.com/en/products/IP-Products/Network-Video-Recorders/Pro-Series/DS-7732NXI-I4-S/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hikvision-ds-7732nxi-i4-s0',
    manufacturer: 'Hikvision',
    model: 'DS-7732NXI-I4-S0',
    category: 'nvr-recorder',
    tagline: 'DS-7732NXI-I4-S0 — 32-channel NVR, 4 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hikvision.com/en/products/IP-Products/Network-Video-Recorders/Pro-Series/DS-7732NXI-I4-S/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hikvision-ds-7732nxi-i4-vpro-msm-moved-msm-moved',
    manufacturer: 'Hikvision',
    model: 'DS-7732NXI-I4-VPRO_MSM_MOVED_MSM_MOVED',
    category: 'nvr-recorder',
    tagline: 'DS-7732NXI-I4-VPRO_MSM_MOVED_MSM_MOVED — 32-channel NVR, 4 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hikvision.com/en/products/IP-Products/Network-Video-Recorders/Pro-Series/DS-7732NXI-I4-S/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hikvision-ds-7732nxi-i4-s-msm-moved',
    manufacturer: 'Hikvision',
    model: 'DS-7732NXI-I4-S_MSM_MOVED',
    category: 'nvr-recorder',
    tagline: 'DS-7732NXI-I4-S_MSM_MOVED — 32-channel NVR, 4 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hikvision.com/en/products/IP-Products/Network-Video-Recorders/Pro-Series/DS-7732NXI-I4-S/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hikvision-ds-7732nxi-i4-16p-vpro',
    manufacturer: 'Hikvision',
    model: 'DS-7732NXI-I4-16P-VPRO',
    category: 'nvr-recorder',
    tagline: 'DS-7732NXI-I4-16P-VPRO — 32-channel NVR, 4 HDD bays, 16-port built-in PoE, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hikvision.com/en/products/IP-Products/Network-Video-Recorders/Pro-Series/DS-7732NXI-I4-16P-S/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hikvision-ds-7732nxi-i4-16p-s',
    manufacturer: 'Hikvision',
    model: 'DS-7732NXI-I4-16P-S',
    category: 'nvr-recorder',
    tagline: 'DS-7732NXI-I4-16P-S — 32-channel NVR, 4 HDD bays, 16-port built-in PoE, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hikvision.com/en/products/IP-Products/Network-Video-Recorders/Pro-Series/DS-7732NXI-I4-16P-S/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hikvision-ds-7732nxi-i4-16p-vpro-msm-moved',
    manufacturer: 'Hikvision',
    model: 'DS-7732NXI-I4-16P-VPRO_MSM_MOVED',
    category: 'nvr-recorder',
    tagline: 'DS-7732NXI-I4-16P-VPRO_MSM_MOVED — 32-channel NVR, 4 HDD bays, 16-port built-in PoE, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hikvision.com/en/products/IP-Products/Network-Video-Recorders/Pro-Series/DS-7732NXI-I4-16P-S/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hikvision-ds-7732nxi-i4-16p-4s',
    manufacturer: 'Hikvision',
    model: 'DS-7732NXI-I4-16P-4S',
    category: 'nvr-recorder',
    tagline: 'DS-7732NXI-I4-16P-4S — 32-channel NVR, 4 HDD bays, 16-port built-in PoE, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hikvision.com/en/products/IP-Products/Network-Video-Recorders/Pro-Series/DS-7732NXI-I4-16P-S/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hikvision-ds-7732nxi-i4-16p-s-e-pl',
    manufacturer: 'Hikvision',
    model: 'DS-7732NXI-I4-16P-S-E-PL',
    category: 'nvr-recorder',
    tagline: 'DS-7732NXI-I4-16P-S-E-PL — 32-channel NVR, 4 HDD bays, 16-port built-in PoE, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hikvision.com/en/products/IP-Products/Network-Video-Recorders/Pro-Series/DS-7732NXI-I4-16P-S/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hikvision-ds-7732nxi-i4-16p-s-brasil',
    manufacturer: 'Hikvision',
    model: 'DS-7732NXI-I4-16P-S-BRASIL',
    category: 'nvr-recorder',
    tagline: 'DS-7732NXI-I4-16P-S-BRASIL — 32-channel NVR, 4 HDD bays, 16-port built-in PoE, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hikvision.com/en/products/IP-Products/Network-Video-Recorders/Pro-Series/DS-7732NXI-I4-16P-S/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hikvision-ds-7732nxi-i4-16p-s-msm-moved',
    manufacturer: 'Hikvision',
    model: 'DS-7732NXI-I4-16P-S_MSM_MOVED',
    category: 'nvr-recorder',
    tagline: 'DS-7732NXI-I4-16P-S_MSM_MOVED — 32-channel NVR, 4 HDD bays, 16-port built-in PoE, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hikvision.com/en/products/IP-Products/Network-Video-Recorders/Pro-Series/DS-7732NXI-I4-16P-S/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-2011a',
    manufacturer: 'Hanwha',
    model: 'XRN-2011A',
    category: 'nvr-recorder',
    tagline: 'XRN-2011A — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-3010a',
    manufacturer: 'Hanwha',
    model: 'XRN-3010A',
    category: 'nvr-recorder',
    tagline: 'XRN-3010A — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-1610sa',
    manufacturer: 'Hanwha',
    model: 'XRN-1610SA',
    category: 'nvr-recorder',
    tagline: 'XRN-1610SA — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-1610a',
    manufacturer: 'Hanwha',
    model: 'XRN-1610A',
    category: 'nvr-recorder',
    tagline: 'XRN-1610A — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-2010a',
    manufacturer: 'Hanwha',
    model: 'XRN-2010A',
    category: 'nvr-recorder',
    tagline: 'XRN-2010A — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-410s',
    manufacturer: 'Hanwha',
    model: 'XRN-410S',
    category: 'nvr-recorder',
    tagline: 'XRN-410S — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-810s',
    manufacturer: 'Hanwha',
    model: 'XRN-810S',
    category: 'nvr-recorder',
    tagline: 'XRN-810S — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-1610s',
    manufacturer: 'Hanwha',
    model: 'XRN-1610S',
    category: 'nvr-recorder',
    tagline: 'XRN-1610S — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-6410db4',
    manufacturer: 'Hanwha',
    model: 'XRN-6410DB4',
    category: 'nvr-recorder',
    tagline: 'XRN-6410DB4 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-6410b4',
    manufacturer: 'Hanwha',
    model: 'XRN-6410B4',
    category: 'nvr-recorder',
    tagline: 'XRN-6410B4 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-3210b4',
    manufacturer: 'Hanwha',
    model: 'XRN-3210B4',
    category: 'nvr-recorder',
    tagline: 'XRN-3210B4 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-6410rb2-60',
    manufacturer: 'Hanwha',
    model: 'XRN-6410RB2-60',
    category: 'nvr-recorder',
    tagline: 'XRN-6410RB2-60 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-6410rb2',
    manufacturer: 'Hanwha',
    model: 'XRN-6410RB2',
    category: 'nvr-recorder',
    tagline: 'XRN-6410RB2 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-3210b2-10t',
    manufacturer: 'Hanwha',
    model: 'XRN-3210B2-10T',
    category: 'nvr-recorder',
    tagline: 'XRN-3210B2-10T — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-6420db4-60',
    manufacturer: 'Hanwha',
    model: 'XRN-6420DB4-60',
    category: 'nvr-recorder',
    tagline: 'XRN-6420DB4-60 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-6420b4-60',
    manufacturer: 'Hanwha',
    model: 'XRN-6420B4-60',
    category: 'nvr-recorder',
    tagline: 'XRN-6420B4-60 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-6420rb2-60',
    manufacturer: 'Hanwha',
    model: 'XRN-6420RB2-60',
    category: 'nvr-recorder',
    tagline: 'XRN-6420RB2-60 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-6410b2-60',
    manufacturer: 'Hanwha',
    model: 'XRN-6410B2-60',
    category: 'nvr-recorder',
    tagline: 'XRN-6410B2-60 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-3220b4-30',
    manufacturer: 'Hanwha',
    model: 'XRN-3220B4-30',
    category: 'nvr-recorder',
    tagline: 'XRN-3220B4-30 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-3220rb2-30',
    manufacturer: 'Hanwha',
    model: 'XRN-3220RB2-30',
    category: 'nvr-recorder',
    tagline: 'XRN-3220RB2-30 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-1620sb1-12',
    manufacturer: 'Hanwha',
    model: 'XRN-1620SB1-12',
    category: 'nvr-recorder',
    tagline: 'XRN-1620SB1-12 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-1620b2-12',
    manufacturer: 'Hanwha',
    model: 'XRN-1620B2-12',
    category: 'nvr-recorder',
    tagline: 'XRN-1620B2-12 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-820s-4t',
    manufacturer: 'Hanwha',
    model: 'XRN-820S-4T',
    category: 'nvr-recorder',
    tagline: 'XRN-820S-4T — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-3220b2-30',
    manufacturer: 'Hanwha',
    model: 'XRN-3220B2-30',
    category: 'nvr-recorder',
    tagline: 'XRN-3220B2-30 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-420s-2t',
    manufacturer: 'Hanwha',
    model: 'XRN-420S-2T',
    category: 'nvr-recorder',
    tagline: 'XRN-420S-2T — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-420s-4t',
    manufacturer: 'Hanwha',
    model: 'XRN-420S-4T',
    category: 'nvr-recorder',
    tagline: 'XRN-420S-4T — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-3210b2-30',
    manufacturer: 'Hanwha',
    model: 'XRN-3210B2-30',
    category: 'nvr-recorder',
    tagline: 'XRN-3210B2-30 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-3210rb2-30',
    manufacturer: 'Hanwha',
    model: 'XRN-3210RB2-30',
    category: 'nvr-recorder',
    tagline: 'XRN-3210RB2-30 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-3210b4-30',
    manufacturer: 'Hanwha',
    model: 'XRN-3210B4-30',
    category: 'nvr-recorder',
    tagline: 'XRN-3210B4-30 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-6410b4-60',
    manufacturer: 'Hanwha',
    model: 'XRN-6410B4-60',
    category: 'nvr-recorder',
    tagline: 'XRN-6410B4-60 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-6410db4-60',
    manufacturer: 'Hanwha',
    model: 'XRN-6410DB4-60',
    category: 'nvr-recorder',
    tagline: 'XRN-6410DB4-60 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-6420b2-60',
    manufacturer: 'Hanwha',
    model: 'XRN-6420B2-60',
    category: 'nvr-recorder',
    tagline: 'XRN-6420B2-60 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-426s-1t',
    manufacturer: 'Hanwha',
    model: 'XRN-426S-1T',
    category: 'nvr-recorder',
    tagline: 'XRN-426S-1T — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-1620b2-6t',
    manufacturer: 'Hanwha',
    model: 'XRN-1620B2-6T',
    category: 'nvr-recorder',
    tagline: 'XRN-1620B2-6T — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-3210rb2',
    manufacturer: 'Hanwha',
    model: 'XRN-3210RB2',
    category: 'nvr-recorder',
    tagline: 'XRN-3210RB2 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-6410b2-10t',
    manufacturer: 'Hanwha',
    model: 'XRN-6410B2-10T',
    category: 'nvr-recorder',
    tagline: 'XRN-6410B2-10T — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-1620sb1-6t',
    manufacturer: 'Hanwha',
    model: 'XRN-1620SB1-6T',
    category: 'nvr-recorder',
    tagline: 'XRN-1620SB1-6T — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-420s',
    manufacturer: 'Hanwha',
    model: 'XRN-420S',
    category: 'nvr-recorder',
    tagline: 'XRN-420S — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-1620sb1',
    manufacturer: 'Hanwha',
    model: 'XRN-1620SB1',
    category: 'nvr-recorder',
    tagline: 'XRN-1620SB1 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-3210b2',
    manufacturer: 'Hanwha',
    model: 'XRN-3210B2',
    category: 'nvr-recorder',
    tagline: 'XRN-3210B2 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-1620b2',
    manufacturer: 'Hanwha',
    model: 'XRN-1620B2',
    category: 'nvr-recorder',
    tagline: 'XRN-1620B2 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-815s',
    manufacturer: 'Hanwha',
    model: 'XRN-815S',
    category: 'nvr-recorder',
    tagline: 'XRN-815S — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-820s',
    manufacturer: 'Hanwha',
    model: 'XRN-820S',
    category: 'nvr-recorder',
    tagline: 'XRN-820S — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-3220b4',
    manufacturer: 'Hanwha',
    model: 'XRN-3220B4',
    category: 'nvr-recorder',
    tagline: 'XRN-3220B4 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-6420db4',
    manufacturer: 'Hanwha',
    model: 'XRN-6420DB4',
    category: 'nvr-recorder',
    tagline: 'XRN-6420DB4 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-6410b2',
    manufacturer: 'Hanwha',
    model: 'XRN-6410B2',
    category: 'nvr-recorder',
    tagline: 'XRN-6410B2 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-6420b4',
    manufacturer: 'Hanwha',
    model: 'XRN-6420B4',
    category: 'nvr-recorder',
    tagline: 'XRN-6420B4 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-3220b2',
    manufacturer: 'Hanwha',
    model: 'XRN-3220B2',
    category: 'nvr-recorder',
    tagline: 'XRN-3220B2 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-3220rb2',
    manufacturer: 'Hanwha',
    model: 'XRN-3220RB2',
    category: 'nvr-recorder',
    tagline: 'XRN-3220RB2 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-6420b2',
    manufacturer: 'Hanwha',
    model: 'XRN-6420B2',
    category: 'nvr-recorder',
    tagline: 'XRN-6420B2 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-6420rb2',
    manufacturer: 'Hanwha',
    model: 'XRN-6420RB2',
    category: 'nvr-recorder',
    tagline: 'XRN-6420RB2 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-xrn-811s',
    manufacturer: 'Hanwha',
    model: 'XRN-811S',
    category: 'nvr-recorder',
    tagline: 'XRN-811S — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch32/xrn-2011a/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 32,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-qrn-1620s-4t',
    manufacturer: 'Hanwha',
    model: 'QRN-1620S-4T',
    category: 'nvr-recorder',
    tagline: 'QRN-1620S-4T — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/nvr/ch16/qrn-1620s-4t/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 128,
      outputBandwidthMbps: 32,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 2-out',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-qrn-820s-3t',
    manufacturer: 'Hanwha',
    model: 'QRN-820S-3T',
    category: 'nvr-recorder',
    tagline: 'QRN-820S-3T — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/nvr/ch16/qrn-1620s-4t/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 128,
      outputBandwidthMbps: 32,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 2-out',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-qrn-410s',
    manufacturer: 'Hanwha',
    model: 'QRN-410S',
    category: 'nvr-recorder',
    tagline: 'QRN-410S — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/nvr/ch16/qrn-1620s-4t/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 128,
      outputBandwidthMbps: 32,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 2-out',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-qrn-1630s-6t',
    manufacturer: 'Hanwha',
    model: 'QRN-1630S-6T',
    category: 'nvr-recorder',
    tagline: 'QRN-1630S-6T — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/nvr/ch16/qrn-1620s-4t/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 128,
      outputBandwidthMbps: 32,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 2-out',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-qrn-830s-4t',
    manufacturer: 'Hanwha',
    model: 'QRN-830S-4T',
    category: 'nvr-recorder',
    tagline: 'QRN-830S-4T — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/nvr/ch16/qrn-1620s-4t/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 128,
      outputBandwidthMbps: 32,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 2-out',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-qrn-430s-2t',
    manufacturer: 'Hanwha',
    model: 'QRN-430S-2T',
    category: 'nvr-recorder',
    tagline: 'QRN-430S-2T — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/nvr/ch16/qrn-1620s-4t/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 128,
      outputBandwidthMbps: 32,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 2-out',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-qrn-430s-4t',
    manufacturer: 'Hanwha',
    model: 'QRN-430S-4T',
    category: 'nvr-recorder',
    tagline: 'QRN-430S-4T — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/nvr/ch16/qrn-1620s-4t/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 128,
      outputBandwidthMbps: 32,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 2-out',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-qrn-420s-2t',
    manufacturer: 'Hanwha',
    model: 'QRN-420S-2T',
    category: 'nvr-recorder',
    tagline: 'QRN-420S-2T — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/nvr/ch16/qrn-1620s-4t/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 128,
      outputBandwidthMbps: 32,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 2-out',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-qrn-1610s',
    manufacturer: 'Hanwha',
    model: 'QRN-1610S',
    category: 'nvr-recorder',
    tagline: 'QRN-1610S — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/nvr/ch16/qrn-1620s-4t/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 128,
      outputBandwidthMbps: 32,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 2-out',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-qrn-1630s',
    manufacturer: 'Hanwha',
    model: 'QRN-1630S',
    category: 'nvr-recorder',
    tagline: 'QRN-1630S — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/nvr/ch16/qrn-1620s-4t/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 128,
      outputBandwidthMbps: 32,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 2-out',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-qrn-810s',
    manufacturer: 'Hanwha',
    model: 'QRN-810S',
    category: 'nvr-recorder',
    tagline: 'QRN-810S — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/nvr/ch16/qrn-1620s-4t/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 128,
      outputBandwidthMbps: 32,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 2-out',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-qrn-420s',
    manufacturer: 'Hanwha',
    model: 'QRN-420S',
    category: 'nvr-recorder',
    tagline: 'QRN-420S — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/nvr/ch16/qrn-1620s-4t/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 128,
      outputBandwidthMbps: 32,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 2-out',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-qrn-820s',
    manufacturer: 'Hanwha',
    model: 'QRN-820S',
    category: 'nvr-recorder',
    tagline: 'QRN-820S — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/nvr/ch16/qrn-1620s-4t/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 128,
      outputBandwidthMbps: 32,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 2-out',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-qrn-830s',
    manufacturer: 'Hanwha',
    model: 'QRN-830S',
    category: 'nvr-recorder',
    tagline: 'QRN-830S — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/nvr/ch16/qrn-1620s-4t/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 128,
      outputBandwidthMbps: 32,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 2-out',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-qrn-1620s',
    manufacturer: 'Hanwha',
    model: 'QRN-1620S',
    category: 'nvr-recorder',
    tagline: 'QRN-1620S — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/nvr/ch16/qrn-1620s-4t/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 128,
      outputBandwidthMbps: 32,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 2-out',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-qrn-430s',
    manufacturer: 'Hanwha',
    model: 'QRN-430S',
    category: 'nvr-recorder',
    tagline: 'QRN-430S — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/nvr/ch16/qrn-1620s-4t/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 128,
      outputBandwidthMbps: 32,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 2-out',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-srn-1673s',
    manufacturer: 'Hanwha',
    model: 'SRN-1673S',
    category: 'nvr-recorder',
    tagline: 'SRN-1673S — 16-channel NVR, 4 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/srn-1673s/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-srn-473s',
    manufacturer: 'Hanwha',
    model: 'SRN-473S',
    category: 'nvr-recorder',
    tagline: 'SRN-473S — 16-channel NVR, 4 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/srn-1673s/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-srn-873s',
    manufacturer: 'Hanwha',
    model: 'SRN-873S',
    category: 'nvr-recorder',
    tagline: 'SRN-873S — 16-channel NVR, 4 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/srn-1673s/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-srn-1670d',
    manufacturer: 'Hanwha',
    model: 'SRN-1670D',
    category: 'nvr-recorder',
    tagline: 'SRN-1670D — 16-channel NVR, 4 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/srn-1673s/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-srn-470d',
    manufacturer: 'Hanwha',
    model: 'SRN-470D',
    category: 'nvr-recorder',
    tagline: 'SRN-470D — 16-channel NVR, 4 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/srn-1673s/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-srn-472s',
    manufacturer: 'Hanwha',
    model: 'SRN-472S',
    category: 'nvr-recorder',
    tagline: 'SRN-472S — 16-channel NVR, 4 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/srn-1673s/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-srn-k3570s',
    manufacturer: 'Hanwha',
    model: 'SRN-K3570S',
    category: 'nvr-recorder',
    tagline: 'SRN-K3570S — 16-channel NVR, 4 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/srn-1673s/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-srn-k3470s',
    manufacturer: 'Hanwha',
    model: 'SRN-K3470S',
    category: 'nvr-recorder',
    tagline: 'SRN-K3470S — 16-channel NVR, 4 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/srn-1673s/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-srn-k3370s',
    manufacturer: 'Hanwha',
    model: 'SRN-K3370S',
    category: 'nvr-recorder',
    tagline: 'SRN-K3370S — 16-channel NVR, 4 HDD bays, 16-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/srn-1673s/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-wrr-p-e200w2',
    manufacturer: 'Hanwha',
    model: 'WRR-P-E200W2',
    category: 'nvr-recorder',
    tagline: 'WRR-P-E200W2 — 128-channel NVR, 8 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/A/wrr-p-e200w2/',
    specs: {
      channels: 128,
      inputBandwidthMbps: 470,
      outputBandwidthMbps: 470,
      maxResolution: '32 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-wrr-p-e200s2',
    manufacturer: 'Hanwha',
    model: 'WRR-P-E200S2',
    category: 'nvr-recorder',
    tagline: 'WRR-P-E200S2 — 128-channel NVR, 8 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/A/wrr-p-e200w2/',
    specs: {
      channels: 128,
      inputBandwidthMbps: 470,
      outputBandwidthMbps: 470,
      maxResolution: '32 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-wrr-p-e200l2',
    manufacturer: 'Hanwha',
    model: 'WRR-P-E200L2',
    category: 'nvr-recorder',
    tagline: 'WRR-P-E200L2 — 128-channel NVR, 8 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/A/wrr-p-e200w2/',
    specs: {
      channels: 128,
      inputBandwidthMbps: 470,
      outputBandwidthMbps: 470,
      maxResolution: '32 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-wrr-p-s202w1',
    manufacturer: 'Hanwha',
    model: 'WRR-P-S202W1',
    category: 'nvr-recorder',
    tagline: 'WRR-P-S202W1 — 128-channel NVR, 8 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/A/wrr-p-e200w2/',
    specs: {
      channels: 128,
      inputBandwidthMbps: 470,
      outputBandwidthMbps: 470,
      maxResolution: '32 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-wrr-p-s202s1',
    manufacturer: 'Hanwha',
    model: 'WRR-P-S202S1',
    category: 'nvr-recorder',
    tagline: 'WRR-P-S202S1 — 128-channel NVR, 8 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/A/wrr-p-e200w2/',
    specs: {
      channels: 128,
      inputBandwidthMbps: 470,
      outputBandwidthMbps: 470,
      maxResolution: '32 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-wrr-p-s202l1',
    manufacturer: 'Hanwha',
    model: 'WRR-P-S202L1',
    category: 'nvr-recorder',
    tagline: 'WRR-P-S202L1 — 128-channel NVR, 8 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/A/wrr-p-e200w2/',
    specs: {
      channels: 128,
      inputBandwidthMbps: 470,
      outputBandwidthMbps: 470,
      maxResolution: '32 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-prn-1600b2',
    manufacturer: 'Hanwha',
    model: 'PRN-1600B2',
    category: 'nvr-recorder',
    tagline: 'PRN-1600B2 — 16-channel NVR, 8 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/prn-1600b2/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 250,
      outputBandwidthMbps: 64,
      maxResolution: '32 MP',
      hddBays: 8,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '3x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-prn-3200b4',
    manufacturer: 'Hanwha',
    model: 'PRN-3200B4',
    category: 'nvr-recorder',
    tagline: 'PRN-3200B4 — 16-channel NVR, 8 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/prn-1600b2/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 250,
      outputBandwidthMbps: 64,
      maxResolution: '32 MP',
      hddBays: 8,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '3x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-prn-6400b4',
    manufacturer: 'Hanwha',
    model: 'PRN-6400B4',
    category: 'nvr-recorder',
    tagline: 'PRN-6400B4 — 16-channel NVR, 8 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/prn-1600b2/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 250,
      outputBandwidthMbps: 64,
      maxResolution: '32 MP',
      hddBays: 8,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '3x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-prn-3200b2',
    manufacturer: 'Hanwha',
    model: 'PRN-3200B2',
    category: 'nvr-recorder',
    tagline: 'PRN-3200B2 — 16-channel NVR, 8 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/prn-1600b2/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 250,
      outputBandwidthMbps: 64,
      maxResolution: '32 MP',
      hddBays: 8,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '3x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-prn-6400db4',
    manufacturer: 'Hanwha',
    model: 'PRN-6400DB4',
    category: 'nvr-recorder',
    tagline: 'PRN-6400DB4 — 16-channel NVR, 8 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/prn-1600b2/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 250,
      outputBandwidthMbps: 64,
      maxResolution: '32 MP',
      hddBays: 8,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '8-in / 4-out',
      networkPorts: '3x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-wrn-810s',
    manufacturer: 'Hanwha',
    model: 'WRN-810S',
    category: 'nvr-recorder',
    tagline: 'WRN-810S — 8-channel NVR, 2 HDD bays, 8-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch8/wrn-810s/',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 8,
      poeBudgetW: 100,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 2-out',
      networkPorts: '2x RJ45 GbE uplink + 8x PoE',
    },
  },
  {
    id: 'hanwha-wrn-1610s',
    manufacturer: 'Hanwha',
    model: 'WRN-1610S',
    category: 'nvr-recorder',
    tagline: 'WRN-1610S — 8-channel NVR, 2 HDD bays, 8-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch8/wrn-810s/',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 8,
      poeBudgetW: 100,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 2-out',
      networkPorts: '2x RJ45 GbE uplink + 8x PoE',
    },
  },
  {
    id: 'hanwha-wrn-2010s',
    manufacturer: 'Hanwha',
    model: 'WRN-2010S',
    category: 'nvr-recorder',
    tagline: 'WRN-2010S — 8-channel NVR, 2 HDD bays, 8-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch8/wrn-810s/',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 8,
      poeBudgetW: 100,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 2-out',
      networkPorts: '2x RJ45 GbE uplink + 8x PoE',
    },
  },
  {
    id: 'hanwha-wrn-2110b1',
    manufacturer: 'Hanwha',
    model: 'WRN-2110B1',
    category: 'nvr-recorder',
    tagline: 'WRN-2110B1 — 8-channel NVR, 2 HDD bays, 8-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch8/wrn-810s/',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 8,
      poeBudgetW: 100,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 2-out',
      networkPorts: '2x RJ45 GbE uplink + 8x PoE',
    },
  },
  {
    id: 'hanwha-wrn-2110sb1',
    manufacturer: 'Hanwha',
    model: 'WRN-2110SB1',
    category: 'nvr-recorder',
    tagline: 'WRN-2110SB1 — 8-channel NVR, 2 HDD bays, 8-port built-in PoE, 8 MP',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch8/wrn-810s/',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 8,
      poeBudgetW: 100,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 2-out',
      networkPorts: '2x RJ45 GbE uplink + 8x PoE',
    },
  },
  {
    id: 'hanwha-trm-410s',
    manufacturer: 'Hanwha',
    model: 'TRM-410S',
    category: 'nvr-recorder',
    tagline: 'TRM-410S — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/trm-1610s/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-trm-1610s',
    manufacturer: 'Hanwha',
    model: 'TRM-1610S',
    category: 'nvr-recorder',
    tagline: 'TRM-1610S — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/trm-1610s/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-trm-810s',
    manufacturer: 'Hanwha',
    model: 'TRM-810S',
    category: 'nvr-recorder',
    tagline: 'TRM-810S — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/trm-1610s/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-trm-1610m',
    manufacturer: 'Hanwha',
    model: 'TRM-1610M',
    category: 'nvr-recorder',
    tagline: 'TRM-1610M — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/trm-1610s/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-wrt-p-3101l',
    manufacturer: 'Hanwha',
    model: 'WRT-P-3101L',
    category: 'nvr-recorder',
    tagline: 'WRT-P-3101L — 128-channel NVR, 4 HDD bays, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/A/wrt-p-5201w/',
    specs: {
      channels: 128,
      inputBandwidthMbps: 300,
      outputBandwidthMbps: 300,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-wrt-p-5201w',
    manufacturer: 'Hanwha',
    model: 'WRT-P-5201W',
    category: 'nvr-recorder',
    tagline: 'WRT-P-5201W — 128-channel NVR, 4 HDD bays, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/A/wrt-p-5201w/',
    specs: {
      channels: 128,
      inputBandwidthMbps: 300,
      outputBandwidthMbps: 300,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-wrt-p-5201l',
    manufacturer: 'Hanwha',
    model: 'WRT-P-5201L',
    category: 'nvr-recorder',
    tagline: 'WRT-P-5201L — 128-channel NVR, 4 HDD bays, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/A/wrt-p-5201w/',
    specs: {
      channels: 128,
      inputBandwidthMbps: 300,
      outputBandwidthMbps: 300,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-wrt-p-3101w',
    manufacturer: 'Hanwha',
    model: 'WRT-P-3101W',
    category: 'nvr-recorder',
    tagline: 'WRT-P-3101W — 128-channel NVR, 4 HDD bays, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/A/wrt-p-5201w/',
    specs: {
      channels: 128,
      inputBandwidthMbps: 300,
      outputBandwidthMbps: 300,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-wwt-p-3201w',
    manufacturer: 'Hanwha',
    model: 'WWT-P-3201W',
    category: 'nvr-recorder',
    tagline: 'WWT-P-3201W — 256-channel NVR, 8 HDD bays, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/A/wwt-p-7401w/',
    specs: {
      channels: 256,
      inputBandwidthMbps: 600,
      outputBandwidthMbps: 600,
      maxResolution: '32 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '4U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-wwt-p-7401w',
    manufacturer: 'Hanwha',
    model: 'WWT-P-7401W',
    category: 'nvr-recorder',
    tagline: 'WWT-P-7401W — 256-channel NVR, 8 HDD bays, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/A/wwt-p-7401w/',
    specs: {
      channels: 256,
      inputBandwidthMbps: 600,
      outputBandwidthMbps: 600,
      maxResolution: '32 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '4U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-wwt-p-7401l',
    manufacturer: 'Hanwha',
    model: 'WWT-P-7401L',
    category: 'nvr-recorder',
    tagline: 'WWT-P-7401L — 256-channel NVR, 8 HDD bays, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/A/wwt-p-7401w/',
    specs: {
      channels: 256,
      inputBandwidthMbps: 600,
      outputBandwidthMbps: 600,
      maxResolution: '32 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '4U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-lrn-410s',
    manufacturer: 'Hanwha',
    model: 'LRN-410S',
    category: 'nvr-recorder',
    tagline: 'LRN-410S — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/lrn-1610s/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-lrn-810s',
    manufacturer: 'Hanwha',
    model: 'LRN-810S',
    category: 'nvr-recorder',
    tagline: 'LRN-810S — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/lrn-1610s/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-lrn-1610s',
    manufacturer: 'Hanwha',
    model: 'LRN-1610S',
    category: 'nvr-recorder',
    tagline: 'LRN-1610S — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/lrn-1610s/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-arn-810s-6t',
    manufacturer: 'Hanwha',
    model: 'ARN-810S-6T',
    category: 'nvr-recorder',
    tagline: 'ARN-810S-6T — 8-channel NVR, 2 HDD bays, 8-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/A/arn-810s-6t/',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 6,
      poeInPorts: 8,
      poeBudgetW: 100,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 8x PoE',
    },
  },
  {
    id: 'hanwha-arn-1610s-6t',
    manufacturer: 'Hanwha',
    model: 'ARN-1610S-6T',
    category: 'nvr-recorder',
    tagline: 'ARN-1610S-6T — 8-channel NVR, 2 HDD bays, 8-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/A/arn-810s-6t/',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 6,
      poeInPorts: 8,
      poeBudgetW: 100,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 8x PoE',
    },
  },
  {
    id: 'hanwha-arn-410s',
    manufacturer: 'Hanwha',
    model: 'ARN-410S',
    category: 'nvr-recorder',
    tagline: 'ARN-410S — 8-channel NVR, 2 HDD bays, 8-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/A/arn-810s-6t/',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 6,
      poeInPorts: 8,
      poeBudgetW: 100,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 8x PoE',
    },
  },
  {
    id: 'hanwha-zrn-e1610',
    manufacturer: 'Hanwha',
    model: 'ZRN-E1610',
    category: 'nvr-recorder',
    tagline: 'ZRN-E1610 — 16-channel NVR, 1 HDD bay, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/zrn-e1610/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 64,
      outputBandwidthMbps: 64,
      maxResolution: '8 MP',
      hddBays: 1,
      hddBayMaxTb: 6,
      poeInPorts: 16,
      poeBudgetW: 100,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-zrn-e410',
    manufacturer: 'Hanwha',
    model: 'ZRN-E410',
    category: 'nvr-recorder',
    tagline: 'ZRN-E410 — 16-channel NVR, 1 HDD bay, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/zrn-e1610/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 64,
      outputBandwidthMbps: 64,
      maxResolution: '8 MP',
      hddBays: 1,
      hddBayMaxTb: 6,
      poeInPorts: 16,
      poeBudgetW: 100,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-zrn-e810',
    manufacturer: 'Hanwha',
    model: 'ZRN-E810',
    category: 'nvr-recorder',
    tagline: 'ZRN-E810 — 16-channel NVR, 1 HDD bay, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/zrn-e1610/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 64,
      outputBandwidthMbps: 64,
      maxResolution: '8 MP',
      hddBays: 1,
      hddBayMaxTb: 6,
      poeInPorts: 16,
      poeBudgetW: 100,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-krn-v810s',
    manufacturer: 'Hanwha',
    model: 'KRN-V810S',
    category: 'nvr-recorder',
    tagline: 'KRN-V810S — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/nvr/ch16/krn-v1610s/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-krn-v1610s',
    manufacturer: 'Hanwha',
    model: 'KRN-V1610S',
    category: 'nvr-recorder',
    tagline: 'KRN-V1610S — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/nvr/ch16/krn-v1610s/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 12,
      poeInPorts: 16,
      poeBudgetW: 130,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'hanwha-par-4000h16',
    manufacturer: 'Hanwha',
    model: 'PAR-4000H16',
    category: 'nvr-recorder',
    tagline: 'PAR-4000H16 — 64-channel NVR, 16 HDD bays, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/nvr/ch64/par-4000h16/',
    specs: {
      channels: 64,
      inputBandwidthMbps: 400,
      outputBandwidthMbps: 400,
      maxResolution: '32 MP',
      hddBays: 16,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '3U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-par-4000h24',
    manufacturer: 'Hanwha',
    model: 'PAR-4000H24',
    category: 'nvr-recorder',
    tagline: 'PAR-4000H24 — 64-channel NVR, 16 HDD bays, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/nvr/ch64/par-4000h16/',
    specs: {
      channels: 64,
      inputBandwidthMbps: 400,
      outputBandwidthMbps: 400,
      maxResolution: '32 MP',
      hddBays: 16,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '3U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'hanwha-taw-4000h16',
    manufacturer: 'Hanwha',
    model: 'TAW-4000H16',
    category: 'nvr-recorder',
    tagline: 'TAW-4000H16 — 16-channel NVR, 4 HDD bays, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/nvr/ch16/taw-4000h16/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'avigilon-nvr5-value',
    manufacturer: 'Avigilon',
    model: 'NVR5-VALUE',
    category: 'nvr-recorder',
    tagline: 'NVR5-VALUE — 128-channel NVR, 8 HDD bays, 61 MP',
    verified: false,
    datasheetUrl: 'https://www.avigilon.com/nvr-systems/nvr5-value',
    specs: {
      channels: 128,
      inputBandwidthMbps: 400,
      outputBandwidthMbps: 400,
      maxResolution: '61 MP',
      hddBays: 8,
      hddBayMaxTb: 12,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      networkPorts: '2x RJ45 GbE + 2x 10 Gb SFP+',
    },
  },
  {
    id: 'avigilon-nvr5-premium',
    manufacturer: 'Avigilon',
    model: 'NVR5-PREMIUM',
    category: 'nvr-recorder',
    tagline: 'NVR5-PREMIUM — 128-channel NVR, 8 HDD bays, 61 MP',
    verified: false,
    datasheetUrl: 'https://www.avigilon.com/nvr-systems/nvr5-value',
    specs: {
      channels: 128,
      inputBandwidthMbps: 400,
      outputBandwidthMbps: 400,
      maxResolution: '61 MP',
      hddBays: 8,
      hddBayMaxTb: 12,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      networkPorts: '2x RJ45 GbE + 2x 10 Gb SFP+',
    },
  },
  {
    id: 'avigilon-nvr5-standard',
    manufacturer: 'Avigilon',
    model: 'NVR5-STANDARD',
    category: 'nvr-recorder',
    tagline: 'NVR5-STANDARD — 128-channel NVR, 8 HDD bays, 61 MP',
    verified: false,
    datasheetUrl: 'https://www.avigilon.com/nvr-systems/nvr5-value',
    specs: {
      channels: 128,
      inputBandwidthMbps: 400,
      outputBandwidthMbps: 400,
      maxResolution: '61 MP',
      hddBays: 8,
      hddBayMaxTb: 12,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      networkPorts: '2x RJ45 GbE + 2x 10 Gb SFP+',
    },
  },
  {
    id: 'avigilon-nvr5-premium-fips',
    manufacturer: 'Avigilon',
    model: 'NVR5-PREMIUM-FIPS',
    category: 'nvr-recorder',
    tagline: 'NVR5-PREMIUM-FIPS — 128-channel NVR, 8 HDD bays, 61 MP',
    verified: false,
    datasheetUrl: 'https://www.avigilon.com/nvr-systems/nvr5-value',
    specs: {
      channels: 128,
      inputBandwidthMbps: 400,
      outputBandwidthMbps: 400,
      maxResolution: '61 MP',
      hddBays: 8,
      hddBayMaxTb: 12,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      networkPorts: '2x RJ45 GbE + 2x 10 Gb SFP+',
    },
  },
  {
    id: 'avigilon-nvr5-premium-hd',
    manufacturer: 'Avigilon',
    model: 'NVR5-PREMIUM-HD',
    category: 'nvr-recorder',
    tagline: 'NVR5-PREMIUM-HD — 128-channel NVR, 8 HDD bays, 61 MP',
    verified: false,
    datasheetUrl: 'https://www.avigilon.com/nvr-systems/nvr5-value',
    specs: {
      channels: 128,
      inputBandwidthMbps: 400,
      outputBandwidthMbps: 400,
      maxResolution: '61 MP',
      hddBays: 8,
      hddBayMaxTb: 12,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '2U',
      networkPorts: '2x RJ45 GbE + 2x 10 Gb SFP+',
    },
  },
  {
    id: 'avigilon-ai-nvr-2x-premium',
    manufacturer: 'Avigilon',
    model: 'AI-NVR-2X-PREMIUM',
    category: 'nvr-recorder',
    tagline: 'AI-NVR-2X-PREMIUM — 200-channel NVR, 16 HDD bays, 61 MP',
    verified: false,
    datasheetUrl: 'https://www.avigilon.com/nvr-systems/ai-nvr-2x-premium',
    specs: {
      channels: 200,
      inputBandwidthMbps: 600,
      outputBandwidthMbps: 600,
      maxResolution: '61 MP',
      hddBays: 16,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '2U',
      networkPorts: '2x RJ45 GbE + 2x 10 Gb SFP+',
    },
  },
  {
    id: 'avigilon-ai-appliance-2x',
    manufacturer: 'Avigilon',
    model: 'AI-APPLIANCE-2X',
    category: 'nvr-recorder',
    tagline: 'AI-APPLIANCE-2X — 200-channel NVR, 16 HDD bays, 61 MP',
    verified: false,
    datasheetUrl: 'https://www.avigilon.com/nvr-systems/ai-nvr-2x-premium',
    specs: {
      channels: 200,
      inputBandwidthMbps: 600,
      outputBandwidthMbps: 600,
      maxResolution: '61 MP',
      hddBays: 16,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '2U',
      networkPorts: '2x RJ45 GbE + 2x 10 Gb SFP+',
    },
  },
  {
    id: 'avigilon-nvr4x-standard',
    manufacturer: 'Avigilon',
    model: 'NVR4X-STANDARD',
    category: 'nvr-recorder',
    tagline: 'NVR4X-STANDARD — 64-channel NVR, 4 HDD bays, 61 MP',
    verified: false,
    datasheetUrl: 'https://www.avigilon.com/nvr-systems/nvr4x-standard',
    specs: {
      channels: 64,
      inputBandwidthMbps: 300,
      outputBandwidthMbps: 300,
      maxResolution: '61 MP',
      hddBays: 4,
      hddBayMaxTb: 12,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '2U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'avigilon-nvr4x-premium-fips',
    manufacturer: 'Avigilon',
    model: 'NVR4X-PREMIUM-FIPS',
    category: 'nvr-recorder',
    tagline: 'NVR4X-PREMIUM-FIPS — 64-channel NVR, 4 HDD bays, 61 MP',
    verified: false,
    datasheetUrl: 'https://www.avigilon.com/nvr-systems/nvr4x-standard',
    specs: {
      channels: 64,
      inputBandwidthMbps: 300,
      outputBandwidthMbps: 300,
      maxResolution: '61 MP',
      hddBays: 4,
      hddBayMaxTb: 12,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '2U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'avigilon-envr2x-appliance',
    manufacturer: 'Avigilon',
    model: 'ENVR2X-APPLIANCE',
    category: 'nvr-recorder',
    tagline: 'ENVR2X-APPLIANCE — 24-channel NVR, 4 HDD bays, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.avigilon.com/nvr-systems/envr2x-appliance',
    specs: {
      channels: 24,
      inputBandwidthMbps: 200,
      outputBandwidthMbps: 200,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 12,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'avigilon-avigilon-rm7-and-nvr5-workstations',
    manufacturer: 'Avigilon',
    model: 'AVIGILON-RM7-AND-NVR5-WORKSTATIONS',
    category: 'nvr-recorder',
    tagline: 'AVIGILON-RM7-AND-NVR5-WORKSTATIONS — 128-channel NVR, 8 HDD bays, 61 MP',
    verified: false,
    datasheetUrl: 'https://www.avigilon.com/nvr-systems/avigilon-rm7-and-nvr5-workstations',
    specs: {
      channels: 128,
      inputBandwidthMbps: 400,
      outputBandwidthMbps: 400,
      maxResolution: '61 MP',
      hddBays: 8,
      hddBayMaxTb: 12,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '2U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'avigilon-nvr6-fips',
    manufacturer: 'Avigilon',
    model: 'NVR6-FIPS',
    category: 'nvr-recorder',
    tagline: 'NVR6-FIPS — 200-channel NVR, 16 HDD bays, 61 MP',
    verified: false,
    datasheetUrl: 'https://www.avigilon.com/nvr-systems/nvr6-fips',
    specs: {
      channels: 200,
      inputBandwidthMbps: 600,
      outputBandwidthMbps: 600,
      maxResolution: '61 MP',
      hddBays: 16,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '2U',
      networkPorts: '2x RJ45 GbE + 2x 10 Gb SFP+',
    },
  },
  {
    id: 'avigilon-nvr4-value',
    manufacturer: 'Avigilon',
    model: 'NVR4-VALUE',
    category: 'nvr-recorder',
    tagline: 'NVR4-VALUE — 24-channel NVR, 4 HDD bays, 30 MP',
    verified: false,
    datasheetUrl: 'https://www.avigilon.com/nvr-systems/nvr4-value',
    specs: {
      channels: 24,
      inputBandwidthMbps: 250,
      outputBandwidthMbps: 250,
      maxResolution: '30 MP',
      hddBays: 4,
      hddBayMaxTb: 12,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'avigilon-rm7x-nvr5x-workstations',
    manufacturer: 'Avigilon',
    model: 'RM7X-NVR5X-WORKSTATIONS',
    category: 'nvr-recorder',
    tagline: 'RM7X-NVR5X-WORKSTATIONS — 128-channel NVR, 8 HDD bays, 61 MP',
    verified: false,
    datasheetUrl: 'https://www.avigilon.com/nvr-systems/rm7x-nvr5x-workstations',
    specs: {
      channels: 128,
      inputBandwidthMbps: 400,
      outputBandwidthMbps: 400,
      maxResolution: '61 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '2U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'avigilon-envr2-plus',
    manufacturer: 'Avigilon',
    model: 'ENVR2-PLUS',
    category: 'nvr-recorder',
    tagline: 'ENVR2-PLUS — 16-channel NVR, 4 HDD bays, 32 MP',
    verified: false,
    datasheetUrl: 'https://www.avigilon.com/nvr-systems/envr2-plus',
    specs: {
      channels: 16,
      inputBandwidthMbps: 200,
      outputBandwidthMbps: 200,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 8,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr301-04b-lp4-iq',
    manufacturer: 'Uniview',
    model: 'NVR301-04B-LP4-IQ',
    category: 'nvr-recorder',
    tagline: 'NVR301-04B-LP4-IQ — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 12 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Easy_Series/1HDD/NVR301-04B-LP4-IQ/',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 24,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 100M uplink + 4x PoE',
    },
  },
  {
    id: 'uniview-nvr301-04b-p4-iq',
    manufacturer: 'Uniview',
    model: 'NVR301-04B-P4-IQ',
    category: 'nvr-recorder',
    tagline: 'NVR301-04B-P4-IQ — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 12 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Easy_Series/1HDD/NVR301-04B-LP4-IQ/',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 24,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 100M uplink + 4x PoE',
    },
  },
  {
    id: 'uniview-nvr301-04b-iq',
    manufacturer: 'Uniview',
    model: 'NVR301-04B-IQ',
    category: 'nvr-recorder',
    tagline: 'NVR301-04B-IQ — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 12 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Easy_Series/1HDD/NVR301-04B-LP4-IQ/',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 24,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 100M uplink + 4x PoE',
    },
  },
  {
    id: 'uniview-nvr301-04s3-p4',
    manufacturer: 'Uniview',
    model: 'NVR301-04S3-P4',
    category: 'nvr-recorder',
    tagline: 'NVR301-04S3-P4 — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 12 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Easy_Series/1HDD/NVR301-04B-LP4-IQ/',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 24,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 100M uplink + 4x PoE',
    },
  },
  {
    id: 'uniview-nvr301-04ls3-p4',
    manufacturer: 'Uniview',
    model: 'NVR301-04LS3-P4',
    category: 'nvr-recorder',
    tagline: 'NVR301-04LS3-P4 — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 12 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Easy_Series/1HDD/NVR301-04B-LP4-IQ/',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 24,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 100M uplink + 4x PoE',
    },
  },
  {
    id: 'uniview-nvr301-04s3',
    manufacturer: 'Uniview',
    model: 'NVR301-04S3',
    category: 'nvr-recorder',
    tagline: 'NVR301-04S3 — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 12 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Easy_Series/1HDD/NVR301-04B-LP4-IQ/',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 24,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 100M uplink + 4x PoE',
    },
  },
  {
    id: 'uniview-nvr301-08s4-lw',
    manufacturer: 'Uniview',
    model: 'NVR301-08S4-LW',
    category: 'nvr-recorder',
    tagline: 'NVR301-08S4-LW — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 12 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Easy_Series/1HDD/NVR301-04B-LP4-IQ/',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 1,
      hddBayMaxTb: 24,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 100M uplink + 4x PoE',
    },
  },
  {
    id: 'uniview-nvr501-04b-p4-a',
    manufacturer: 'Uniview',
    model: 'NVR501-04B-P4-A',
    category: 'nvr-recorder',
    tagline: 'NVR501-04B-P4-A — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 16 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/1HDD/NVR501-04B-P4-A/',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 64,
      maxResolution: '16 MP',
      hddBays: 1,
      hddBayMaxTb: 24,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 1-out',
      networkPorts: '1x RJ45 100M uplink + 4x PoE',
    },
  },
  {
    id: 'uniview-nvr501-04b-p4',
    manufacturer: 'Uniview',
    model: 'NVR501-04B-P4',
    category: 'nvr-recorder',
    tagline: 'NVR501-04B-P4 — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 16 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/1HDD/NVR501-04B-P4-A/',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 64,
      maxResolution: '16 MP',
      hddBays: 1,
      hddBayMaxTb: 24,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 1-out',
      networkPorts: '1x RJ45 100M uplink + 4x PoE',
    },
  },
  {
    id: 'uniview-nvr501-04b-lp4',
    manufacturer: 'Uniview',
    model: 'NVR501-04B-LP4',
    category: 'nvr-recorder',
    tagline: 'NVR501-04B-LP4 — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 16 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/1HDD/NVR501-04B-P4-A/',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 64,
      maxResolution: '16 MP',
      hddBays: 1,
      hddBayMaxTb: 24,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 1-out',
      networkPorts: '1x RJ45 100M uplink + 4x PoE',
    },
  },
  {
    id: 'uniview-nvr501-04b',
    manufacturer: 'Uniview',
    model: 'NVR501-04B',
    category: 'nvr-recorder',
    tagline: 'NVR501-04B — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 16 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/1HDD/NVR501-04B-P4-A/',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 64,
      maxResolution: '16 MP',
      hddBays: 1,
      hddBayMaxTb: 24,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 1-out',
      networkPorts: '1x RJ45 100M uplink + 4x PoE',
    },
  },
  {
    id: 'uniview-nvr501-04b-lp4-iq',
    manufacturer: 'Uniview',
    model: 'NVR501-04B-LP4-IQ',
    category: 'nvr-recorder',
    tagline: 'NVR501-04B-LP4-IQ — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 16 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/1HDD/NVR501-04B-P4-A/',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 64,
      maxResolution: '16 MP',
      hddBays: 1,
      hddBayMaxTb: 24,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 1-out',
      networkPorts: '1x RJ45 100M uplink + 4x PoE',
    },
  },
  {
    id: 'uniview-nvr501-04b-p4-iq',
    manufacturer: 'Uniview',
    model: 'NVR501-04B-P4-IQ',
    category: 'nvr-recorder',
    tagline: 'NVR501-04B-P4-IQ — 4-channel NVR, 1 HDD bay, 4-port built-in PoE, 16 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/1HDD/NVR501-04B-P4-A/',
    specs: {
      channels: 4,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 64,
      maxResolution: '16 MP',
      hddBays: 1,
      hddBayMaxTb: 24,
      poeInPorts: 4,
      poeBudgetW: 50,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '4-in / 1-out',
      networkPorts: '1x RJ45 100M uplink + 4x PoE',
    },
  },
  {
    id: 'uniview-nvr502-09b-iq',
    manufacturer: 'Uniview',
    model: 'NVR502-09B-IQ',
    category: 'nvr-recorder',
    tagline: 'NVR502-09B-IQ — 9-channel NVR, 2 HDD bays, 16 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/2HDD/NVR502-09B-IQ/',
    specs: {
      channels: 9,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 160,
      maxResolution: '16 MP',
      hddBays: 2,
      hddBayMaxTb: 24,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '8-in / 2-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr502-08b-p8-iq',
    manufacturer: 'Uniview',
    model: 'NVR502-08B-P8-IQ',
    category: 'nvr-recorder',
    tagline: 'NVR502-08B-P8-IQ — 9-channel NVR, 2 HDD bays, 16 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/2HDD/NVR502-09B-IQ/',
    specs: {
      channels: 9,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 160,
      maxResolution: '16 MP',
      hddBays: 2,
      hddBayMaxTb: 24,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '8-in / 2-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr502-08b-p8',
    manufacturer: 'Uniview',
    model: 'NVR502-08B-P8',
    category: 'nvr-recorder',
    tagline: 'NVR502-08B-P8 — 9-channel NVR, 2 HDD bays, 16 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/2HDD/NVR502-09B-IQ/',
    specs: {
      channels: 9,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 160,
      maxResolution: '16 MP',
      hddBays: 2,
      hddBayMaxTb: 24,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '8-in / 2-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr502-09b',
    manufacturer: 'Uniview',
    model: 'NVR502-09B',
    category: 'nvr-recorder',
    tagline: 'NVR502-09B — 9-channel NVR, 2 HDD bays, 16 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/2HDD/NVR502-09B-IQ/',
    specs: {
      channels: 9,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 160,
      maxResolution: '16 MP',
      hddBays: 2,
      hddBayMaxTb: 24,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '8-in / 2-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr502-32e-ix-g',
    manufacturer: 'Uniview',
    model: 'NVR502-32E-IX-G',
    category: 'nvr-recorder',
    tagline: 'NVR502-32E-IX-G — 9-channel NVR, 2 HDD bays, 16 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/2HDD/NVR502-09B-IQ/',
    specs: {
      channels: 9,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 160,
      maxResolution: '16 MP',
      hddBays: 2,
      hddBayMaxTb: 24,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '8-in / 2-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr502-16e-im-g',
    manufacturer: 'Uniview',
    model: 'NVR502-16E-IM-G',
    category: 'nvr-recorder',
    tagline: 'NVR502-16E-IM-G — 9-channel NVR, 2 HDD bays, 16 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/2HDD/NVR502-09B-IQ/',
    specs: {
      channels: 9,
      inputBandwidthMbps: 320,
      outputBandwidthMbps: 160,
      maxResolution: '16 MP',
      hddBays: 2,
      hddBayMaxTb: 24,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '8-in / 2-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr504-16e-iq',
    manufacturer: 'Uniview',
    model: 'NVR504-16E-IQ',
    category: 'nvr-recorder',
    tagline: 'NVR504-16E-IQ — 16-channel NVR, 4 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/4HDD/NVR504-16E-IQ/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 24,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 10-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr504-16b-iq',
    manufacturer: 'Uniview',
    model: 'NVR504-16B-IQ',
    category: 'nvr-recorder',
    tagline: 'NVR504-16B-IQ — 16-channel NVR, 4 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/4HDD/NVR504-16E-IQ/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 24,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 10-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr504-16b-p16-iq',
    manufacturer: 'Uniview',
    model: 'NVR504-16B-P16-IQ',
    category: 'nvr-recorder',
    tagline: 'NVR504-16B-P16-IQ — 16-channel NVR, 4 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/4HDD/NVR504-16E-IQ/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 24,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 10-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr504-16b-p16',
    manufacturer: 'Uniview',
    model: 'NVR504-16B-P16',
    category: 'nvr-recorder',
    tagline: 'NVR504-16B-P16 — 16-channel NVR, 4 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/4HDD/NVR504-16E-IQ/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 24,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 10-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr504-16b',
    manufacturer: 'Uniview',
    model: 'NVR504-16B',
    category: 'nvr-recorder',
    tagline: 'NVR504-16B — 16-channel NVR, 4 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/4HDD/NVR504-16E-IQ/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 24,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 10-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr504-16e-p16-iq',
    manufacturer: 'Uniview',
    model: 'NVR504-16E-P16-IQ',
    category: 'nvr-recorder',
    tagline: 'NVR504-16E-P16-IQ — 16-channel NVR, 4 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/4HDD/NVR504-16E-IQ/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 4,
      hddBayMaxTb: 24,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 10-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr824-128-r-ix-8g',
    manufacturer: 'Uniview',
    model: 'NVR824-128-R-IX-8G',
    category: 'nvr-recorder',
    tagline: 'NVR824-128-R-IX-8G — 128-channel NVR, 24 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Pro_Series/24HDD/NVR824-128-R-IX-8G/',
    specs: {
      channels: 128,
      inputBandwidthMbps: 768,
      outputBandwidthMbps: 768,
      maxResolution: '12 MP',
      hddBays: 24,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '4U',
      alarmIO: '24-in / 8-out',
      networkPorts: '4x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr824-128-r-im-8g',
    manufacturer: 'Uniview',
    model: 'NVR824-128-R-IM-8G',
    category: 'nvr-recorder',
    tagline: 'NVR824-128-R-IM-8G — 128-channel NVR, 24 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Pro_Series/24HDD/NVR824-128-R-IX-8G/',
    specs: {
      channels: 128,
      inputBandwidthMbps: 768,
      outputBandwidthMbps: 768,
      maxResolution: '12 MP',
      hddBays: 24,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '4U',
      alarmIO: '24-in / 8-out',
      networkPorts: '4x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr824-128-r-im2-8g',
    manufacturer: 'Uniview',
    model: 'NVR824-128-R-IM2-8G',
    category: 'nvr-recorder',
    tagline: 'NVR824-128-R-IM2-8G — 128-channel NVR, 24 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Pro_Series/24HDD/NVR824-128-R-IX-8G/',
    specs: {
      channels: 128,
      inputBandwidthMbps: 768,
      outputBandwidthMbps: 768,
      maxResolution: '12 MP',
      hddBays: 24,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '4U',
      alarmIO: '24-in / 8-out',
      networkPorts: '4x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr824-128-r-ix2-8g',
    manufacturer: 'Uniview',
    model: 'NVR824-128-R-IX2-8G',
    category: 'nvr-recorder',
    tagline: 'NVR824-128-R-IX2-8G — 128-channel NVR, 24 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Pro_Series/24HDD/NVR824-128-R-IX-8G/',
    specs: {
      channels: 128,
      inputBandwidthMbps: 768,
      outputBandwidthMbps: 768,
      maxResolution: '12 MP',
      hddBays: 24,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '4U',
      alarmIO: '24-in / 8-out',
      networkPorts: '4x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr824-128r',
    manufacturer: 'Uniview',
    model: 'NVR824-128R',
    category: 'nvr-recorder',
    tagline: 'NVR824-128R — 128-channel NVR, 24 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Pro_Series/24HDD/NVR824-128-R-IX-8G/',
    specs: {
      channels: 128,
      inputBandwidthMbps: 768,
      outputBandwidthMbps: 768,
      maxResolution: '12 MP',
      hddBays: 24,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '4U',
      alarmIO: '24-in / 8-out',
      networkPorts: '4x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr508-32e-iq',
    manufacturer: 'Uniview',
    model: 'NVR508-32E-IQ',
    category: 'nvr-recorder',
    tagline: 'NVR508-32E-IQ — 32-channel NVR, 8 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/8HDD/NVR508-32E-IQ/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 8,
      hddBayMaxTb: 24,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 10-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr508-32e-r-iq',
    manufacturer: 'Uniview',
    model: 'NVR508-32E-R-IQ',
    category: 'nvr-recorder',
    tagline: 'NVR508-32E-R-IQ — 32-channel NVR, 8 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/8HDD/NVR508-32E-IQ/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 8,
      hddBayMaxTb: 24,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 10-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr508-32e-r',
    manufacturer: 'Uniview',
    model: 'NVR508-32E-R',
    category: 'nvr-recorder',
    tagline: 'NVR508-32E-R — 32-channel NVR, 8 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/8HDD/NVR508-32E-IQ/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 8,
      hddBayMaxTb: 24,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 10-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr508-16b',
    manufacturer: 'Uniview',
    model: 'NVR508-16B',
    category: 'nvr-recorder',
    tagline: 'NVR508-16B — 32-channel NVR, 8 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/8HDD/NVR508-32E-IQ/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 384,
      outputBandwidthMbps: 384,
      maxResolution: '32 MP',
      hddBays: 8,
      hddBayMaxTb: 24,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 10-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr302-16b-p16-iq',
    manufacturer: 'Uniview',
    model: 'NVR302-16B-P16-IQ',
    category: 'nvr-recorder',
    tagline: 'NVR302-16B-P16-IQ — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 12 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Easy_Series/2HDD/NVR302-16B-P16-IQ/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 128,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 24,
      poeInPorts: 16,
      poeBudgetW: 240,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '8-in / 2-out',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'uniview-nvr302-08b-p8-iq',
    manufacturer: 'Uniview',
    model: 'NVR302-08B-P8-IQ',
    category: 'nvr-recorder',
    tagline: 'NVR302-08B-P8-IQ — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 12 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Easy_Series/2HDD/NVR302-16B-P16-IQ/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 128,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 24,
      poeInPorts: 16,
      poeBudgetW: 240,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '8-in / 2-out',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'uniview-nvr302-09b-iq',
    manufacturer: 'Uniview',
    model: 'NVR302-09B-IQ',
    category: 'nvr-recorder',
    tagline: 'NVR302-09B-IQ — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 12 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Easy_Series/2HDD/NVR302-16B-P16-IQ/',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 128,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 24,
      poeInPorts: 16,
      poeBudgetW: 240,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      alarmIO: '8-in / 2-out',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'uniview-nvr516-64e-r',
    manufacturer: 'Uniview',
    model: 'NVR516-64E-R',
    category: 'nvr-recorder',
    tagline: 'NVR516-64E-R — 64-channel NVR, 16 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/16HDD/NVR516-64E-R/',
    specs: {
      channels: 64,
      inputBandwidthMbps: 640,
      outputBandwidthMbps: 640,
      maxResolution: '32 MP',
      hddBays: 16,
      hddBayMaxTb: 24,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '3U',
      alarmIO: '16-in / 10-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr516-32s',
    manufacturer: 'Uniview',
    model: 'NVR516-32S',
    category: 'nvr-recorder',
    tagline: 'NVR516-32S — 64-channel NVR, 16 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/16HDD/NVR516-64E-R/',
    specs: {
      channels: 64,
      inputBandwidthMbps: 640,
      outputBandwidthMbps: 640,
      maxResolution: '32 MP',
      hddBays: 16,
      hddBayMaxTb: 24,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '3U',
      alarmIO: '16-in / 10-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr516-64',
    manufacturer: 'Uniview',
    model: 'NVR516-64',
    category: 'nvr-recorder',
    tagline: 'NVR516-64 — 64-channel NVR, 16 HDD bays, 32 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Prime_Series/16HDD/NVR516-64E-R/',
    specs: {
      channels: 64,
      inputBandwidthMbps: 640,
      outputBandwidthMbps: 640,
      maxResolution: '32 MP',
      hddBays: 16,
      hddBayMaxTb: 24,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '3U',
      alarmIO: '16-in / 10-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr816-64-r-im-4g',
    manufacturer: 'Uniview',
    model: 'NVR816-64-R-IM-4G',
    category: 'nvr-recorder',
    tagline: 'NVR816-64-R-IM-4G — 64-channel NVR, 16 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Pro_Series/16HDD/NVR816-64-R-IM-4G/',
    specs: {
      channels: 64,
      inputBandwidthMbps: 512,
      outputBandwidthMbps: 512,
      maxResolution: '12 MP',
      hddBays: 16,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '3U',
      alarmIO: '24-in / 8-out',
      networkPorts: '4x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr816-64',
    manufacturer: 'Uniview',
    model: 'NVR816-64',
    category: 'nvr-recorder',
    tagline: 'NVR816-64 — 64-channel NVR, 16 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Pro_Series/16HDD/NVR816-64-R-IM-4G/',
    specs: {
      channels: 64,
      inputBandwidthMbps: 512,
      outputBandwidthMbps: 512,
      maxResolution: '12 MP',
      hddBays: 16,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '3U',
      alarmIO: '24-in / 8-out',
      networkPorts: '4x RJ45 GbE',
    },
  },
  {
    id: 'uniview-nvr816-64-r-im2-4g',
    manufacturer: 'Uniview',
    model: 'NVR816-64-R-IM2-4G',
    category: 'nvr-recorder',
    tagline: 'NVR816-64-R-IM2-4G — 64-channel NVR, 16 HDD bays, 12 MP',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Network_Video_Recorders/Pro_Series/16HDD/NVR816-64-R-IM-4G/',
    specs: {
      channels: 64,
      inputBandwidthMbps: 512,
      outputBandwidthMbps: 512,
      maxResolution: '12 MP',
      hddBays: 16,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '3U',
      alarmIO: '24-in / 8-out',
      networkPorts: '4x RJ45 GbE',
    },
  },
  {
    id: 'arecont-vision-nvr-bundle-16-channel-nvr-mix-n-match',
    manufacturer: 'Arecont Vision',
    model: 'NVR-BUNDLE-16-CHANNEL-NVR-MIX-N-MATCH',
    category: 'nvr-recorder',
    tagline: 'NVR-BUNDLE-16-CHANNEL-NVR-MIX-N-MATCH — 16-channel NVR, 4 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://buy.arecontvision.com/products/nvr-bundle-av1600-8t0-16x-av2325dnir',
    specs: {
      channels: 16,
      inputBandwidthMbps: 200,
      outputBandwidthMbps: 200,
      maxResolution: '12 MP',
      hddBays: 4,
      hddBayMaxTb: 8,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'arecont-vision-nvr-bundle-av1600-8t0-16x-av2325dnir',
    manufacturer: 'Arecont Vision',
    model: 'NVR-BUNDLE-AV1600-8T0-16X-AV2325DNIR',
    category: 'nvr-recorder',
    tagline: 'NVR-BUNDLE-AV1600-8T0-16X-AV2325DNIR — 16-channel NVR, 4 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://buy.arecontvision.com/products/nvr-bundle-av1600-8t0-16x-av2325dnir',
    specs: {
      channels: 16,
      inputBandwidthMbps: 200,
      outputBandwidthMbps: 200,
      maxResolution: '12 MP',
      hddBays: 4,
      hddBayMaxTb: 8,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'arecont-vision-nvr-bundle-av1600-8t0-16x-av3325dnir',
    manufacturer: 'Arecont Vision',
    model: 'NVR-BUNDLE-AV1600-8T0-16X-AV3325DNIR',
    category: 'nvr-recorder',
    tagline: 'NVR-BUNDLE-AV1600-8T0-16X-AV3325DNIR — 16-channel NVR, 4 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://buy.arecontvision.com/products/nvr-bundle-av1600-8t0-16x-av2325dnir',
    specs: {
      channels: 16,
      inputBandwidthMbps: 200,
      outputBandwidthMbps: 200,
      maxResolution: '12 MP',
      hddBays: 4,
      hddBayMaxTb: 8,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'arecont-vision-nvr-bundle-av800-4t0-8x-av2325dnir',
    manufacturer: 'Arecont Vision',
    model: 'NVR-BUNDLE-AV800-4T0-8X-AV2325DNIR',
    category: 'nvr-recorder',
    tagline: 'NVR-BUNDLE-AV800-4T0-8X-AV2325DNIR — 16-channel NVR, 4 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://buy.arecontvision.com/products/nvr-bundle-av1600-8t0-16x-av2325dnir',
    specs: {
      channels: 16,
      inputBandwidthMbps: 200,
      outputBandwidthMbps: 200,
      maxResolution: '12 MP',
      hddBays: 4,
      hddBayMaxTb: 8,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'arecont-vision-nvr-bundle-av800-4t0-8x-av3325dnir',
    manufacturer: 'Arecont Vision',
    model: 'NVR-BUNDLE-AV800-4T0-8X-AV3325DNIR',
    category: 'nvr-recorder',
    tagline: 'NVR-BUNDLE-AV800-4T0-8X-AV3325DNIR — 16-channel NVR, 4 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://buy.arecontvision.com/products/nvr-bundle-av1600-8t0-16x-av2325dnir',
    specs: {
      channels: 16,
      inputBandwidthMbps: 200,
      outputBandwidthMbps: 200,
      maxResolution: '12 MP',
      hddBays: 4,
      hddBayMaxTb: 8,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'kedacom-nvr2820-t',
    manufacturer: 'KEDACOM',
    model: 'NVR2820-T',
    category: 'nvr-recorder',
    tagline: 'NVR2820-T — 128-channel NVR, 16 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://kedacom.com/cn/kdm/products/nvr2820-t.html',
    specs: {
      channels: 128,
      inputBandwidthMbps: 512,
      outputBandwidthMbps: 512,
      maxResolution: '12 MP',
      hddBays: 16,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '3U',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'kedacom-nvr2860-t',
    manufacturer: 'KEDACOM',
    model: 'NVR2860-T',
    category: 'nvr-recorder',
    tagline: 'NVR2860-T — 256-channel NVR, 24 HDD bays, 32 MP',
    verified: false,
    datasheetUrl: 'https://kedacom.com/cn/kdm/products/nvr2860-t.html',
    specs: {
      channels: 256,
      inputBandwidthMbps: 1024,
      outputBandwidthMbps: 1024,
      maxResolution: '32 MP',
      hddBays: 24,
      hddBayMaxTb: 16,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: '4U',
      networkPorts: '2x RJ45 GbE + 2x 10 Gb SFP+',
    },
  },
  {
    id: 'linovision-nvr9216-16p-4k',
    manufacturer: 'Linovision',
    model: 'NVR9216-16P-4K',
    category: 'nvr-recorder',
    tagline: 'NVR9216-16P-4K — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://linovision.com/products/nvr9216-16p-4k',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'lorex-nr8163w-1-p',
    manufacturer: 'Lorex',
    model: 'NR8163W-1-P',
    category: 'nvr-recorder',
    tagline: 'NR8163W-1-P — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.lorextechnology.com/nvr-network-video-recorder/16-channel-hd-security-nvr/NR8163W-1-p',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 192,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'lorex-lnr6100x-series-0-p',
    manufacturer: 'Lorex',
    model: 'LNR6100X-SERIES-0-P',
    category: 'nvr-recorder',
    tagline: 'LNR6100X-SERIES-0-P — 8-channel NVR, 1 HDD bay, 8-port built-in PoE, 4K',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.lorextechnology.com/nvr-network-video-recorder/4k-nvr-with-16-channels-and-3-terabyte-hard-drive/LNR6100X-Series-0-p',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 10,
      poeInPorts: 8,
      poeBudgetW: 96,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 8x PoE',
    },
  },
  {
    id: 'lorex-lnr61082tw-1-p',
    manufacturer: 'Lorex',
    model: 'LNR61082TW-1-P',
    category: 'nvr-recorder',
    tagline: 'LNR61082TW-1-P — 8-channel NVR, 1 HDD bay, 8-port built-in PoE, 4K',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.lorextechnology.com/nvr-network-video-recorder/4k-nvr-with-16-channels-and-3-terabyte-hard-drive/LNR61082TW-1-p',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 10,
      poeInPorts: 8,
      poeBudgetW: 96,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 8x PoE',
    },
  },
  {
    id: 'lorex-nr8182w-1-p',
    manufacturer: 'Lorex',
    model: 'NR8182W-1-P',
    category: 'nvr-recorder',
    tagline: 'NR8182W-1-P — 8-channel NVR, 1 HDD bay, 8-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.lorextechnology.com/nvr-network-video-recorder/4k-nvr-with-16-channels-and-3-terabyte-hard-drive/NR8182W-1-p',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 1,
      hddBayMaxTb: 10,
      poeInPorts: 8,
      poeBudgetW: 96,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 8x PoE',
    },
  },
  {
    id: 'lorex-nr9163-1-p',
    manufacturer: 'Lorex',
    model: 'NR9163-1-P',
    category: 'nvr-recorder',
    tagline: 'NR9163-1-P — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 4K',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.lorextechnology.com/nvr-network-video-recorder/4k-nvr-with-16-channels-and-3-terabyte-hard-drive/NR9163-1-p',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '4K',
      hddBays: 2,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 192,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'lorex-lnk7000x-series-1-p',
    manufacturer: 'Lorex',
    model: 'LNK7000X-SERIES-1-P',
    category: 'nvr-recorder',
    tagline: 'LNK7000X-SERIES-1-P — 8-channel NVR, 1 HDD bay, 8-port built-in PoE, 4K',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.lorextechnology.com/nvr-network-video-recorder/4k-nvr-with-8-channels-and-2-terabyte-hard-drive/LNK7000X-Series-1-p',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 10,
      poeInPorts: 8,
      poeBudgetW: 96,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 8x PoE',
    },
  },
  {
    id: 'lorex-nr9082-1-p',
    manufacturer: 'Lorex',
    model: 'NR9082-1-P',
    category: 'nvr-recorder',
    tagline: 'NR9082-1-P — 8-channel NVR, 1 HDD bay, 8-port built-in PoE, 4K',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.lorextechnology.com/nvr-network-video-recorder/4k-nvr-with-8-channels-and-2-terabyte-hard-drive/NR9082-1-p',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 10,
      poeInPorts: 8,
      poeBudgetW: 96,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 8x PoE',
    },
  },
  {
    id: 'lorex-n841-series-1-p',
    manufacturer: 'Lorex',
    model: 'N841-SERIES-1-P',
    category: 'nvr-recorder',
    tagline: 'N841-SERIES-1-P — 8-channel NVR, 1 HDD bay, 8-port built-in PoE, 4K',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.lorextechnology.com/nvr-network-video-recorder/4k-nvr-with-smart-detection/N841-Series-1-p',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 10,
      poeInPorts: 8,
      poeBudgetW: 96,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 8x PoE',
    },
  },
  {
    id: 'lorex-n841a82-w-1-p',
    manufacturer: 'Lorex',
    model: 'N841A82-W-1-P',
    category: 'nvr-recorder',
    tagline: 'N841A82-W-1-P — 8-channel NVR, 1 HDD bay, 8-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.lorextechnology.com/nvr-network-video-recorder/4k-nvr-with-smart-detection/N841A82-W-1-p',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 1,
      hddBayMaxTb: 10,
      poeInPorts: 8,
      poeBudgetW: 96,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 8x PoE',
    },
  },
  {
    id: 'lorex-n861d63b-1-p',
    manufacturer: 'Lorex',
    model: 'N861D63B-1-P',
    category: 'nvr-recorder',
    tagline: 'N861D63B-1-P — 16-channel NVR, 1 HDD bay, 16-port built-in PoE, 4K',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.lorextechnology.com/nvr-network-video-recorder/4k-nvr-with-smart-detection/N861D63B-1-p',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 192,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'lorex-n842-series-1-p',
    manufacturer: 'Lorex',
    model: 'N842-SERIES-1-P',
    category: 'nvr-recorder',
    tagline: 'N842-SERIES-1-P — 8-channel NVR, 1 HDD bay, 8-port built-in PoE, 4K',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.lorextechnology.com/nvr-network-video-recorder/4k-nvr-with-smart-motion-detection/N842-Series-1-p',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 10,
      poeInPorts: 8,
      poeBudgetW: 96,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 8x PoE',
    },
  },
  {
    id: 'lorex-n843-series-1-p',
    manufacturer: 'Lorex',
    model: 'N843-SERIES-1-P',
    category: 'nvr-recorder',
    tagline: 'N843-SERIES-1-P — 8-channel NVR, 1 HDD bay, 8-port built-in PoE, 4K',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.lorextechnology.com/nvr-network-video-recorder/4k-nvr-with-smart-motion-detection/N843-Series-1-p',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 10,
      poeInPorts: 8,
      poeBudgetW: 96,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 8x PoE',
    },
  },
  {
    id: 'lorex-nr900x-series-1-p',
    manufacturer: 'Lorex',
    model: 'NR900X-SERIES-1-P',
    category: 'nvr-recorder',
    tagline: 'NR900X-SERIES-1-P — 8-channel NVR, 1 HDD bay, 8-port built-in PoE, 4K',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.lorextechnology.com/nvr-network-video-recorder/4k-security-nvr/NR900X-Series-1-p',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 10,
      poeInPorts: 8,
      poeBudgetW: 96,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 8x PoE',
    },
  },
  {
    id: 'lorex-nr8081w-1-p',
    manufacturer: 'Lorex',
    model: 'NR8081W-1-P',
    category: 'nvr-recorder',
    tagline: 'NR8081W-1-P — 8-channel NVR, 1 HDD bay, 8-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.lorextechnology.com/nvr-network-video-recorder/8-channel-hd-security-nvr/NR8081W-1-p',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 1,
      hddBayMaxTb: 10,
      poeInPorts: 8,
      poeBudgetW: 96,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 8x PoE',
    },
  },
  {
    id: 'lorex-lnr400-series-1-p',
    manufacturer: 'Lorex',
    model: 'LNR400-SERIES-1-P',
    category: 'nvr-recorder',
    tagline: 'LNR400-SERIES-1-P — 8-channel NVR, 1 HDD bay, 8-port built-in PoE, 4 MP',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.lorextechnology.com/nvr-network-video-recorder/hd-security-nvr-lnr400-series/LNR400-Series-1-p',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '4 MP',
      hddBays: 1,
      hddBayMaxTb: 10,
      poeInPorts: 8,
      poeBudgetW: 96,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 8x PoE',
    },
  },
  {
    id: 'lorex-l871t8-series-1-p',
    manufacturer: 'Lorex',
    model: 'L871T8-SERIES-1-P',
    category: 'nvr-recorder',
    tagline: 'L871T8-SERIES-1-P — 8-channel NVR, 1 HDD bay, 8-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.lorextechnology.com/nvr-network-video-recorder/lorex-home-center/L871T8-Series-1-p',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 1,
      hddBayMaxTb: 10,
      poeInPorts: 8,
      poeBudgetW: 96,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 8x PoE',
    },
  },
  {
    id: 'lts-platinum-network-video-recorder-ltn07256-r16-html-22',
    manufacturer: 'LTS',
    model: 'PLATINUM-NETWORK-VIDEO-RECORDER-LTN07256-R16.HTML%22',
    category: 'nvr-recorder',
    tagline: 'PLATINUM-NETWORK-VIDEO-RECORDER-LTN07256-R16.HTML%22 — 32-channel NVR, 8 HDD bays, 16-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.ltsecurityinc.com/nvr/platinum-network-video-recorder-nvr-ltn8932-p16',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'lts-platinum-network-video-recorder-nvr-ltn8832',
    manufacturer: 'LTS',
    model: 'PLATINUM-NETWORK-VIDEO-RECORDER-NVR-LTN8832',
    category: 'nvr-recorder',
    tagline: 'PLATINUM-NETWORK-VIDEO-RECORDER-NVR-LTN8832 — 32-channel NVR, 8 HDD bays, 16-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.ltsecurityinc.com/nvr/platinum-network-video-recorder-nvr-ltn8932-p16',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'lts-platinum-network-video-recorder-nvr-ltn8932-p16',
    manufacturer: 'LTS',
    model: 'PLATINUM-NETWORK-VIDEO-RECORDER-NVR-LTN8932-P16',
    category: 'nvr-recorder',
    tagline: 'PLATINUM-NETWORK-VIDEO-RECORDER-NVR-LTN8932-P16 — 32-channel NVR, 8 HDD bays, 16-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.ltsecurityinc.com/nvr/platinum-network-video-recorder-nvr-ltn8932-p16',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'lts-platinum-network-video-recorder-nvr-ltn8932',
    manufacturer: 'LTS',
    model: 'PLATINUM-NETWORK-VIDEO-RECORDER-NVR-LTN8932',
    category: 'nvr-recorder',
    tagline: 'PLATINUM-NETWORK-VIDEO-RECORDER-NVR-LTN8932 — 32-channel NVR, 8 HDD bays, 16-port built-in PoE, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.ltsecurityinc.com/nvr/platinum-network-video-recorder-nvr-ltn8932-p16',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'lts-ltn7716-p16',
    manufacturer: 'LTS',
    model: 'LTN7716-P16',
    category: 'nvr-recorder',
    tagline: 'LTN7716-P16 — 16-channel NVR, 4 HDD bays, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.ltsecurityinc.com/nvr/embedded-nvr/ltn7716-p16',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '8 MP',
      hddBays: 4,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      alarmIO: '16-in / 4-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'lts-ltn7716-p8',
    manufacturer: 'LTS',
    model: 'LTN7716-P8',
    category: 'nvr-recorder',
    tagline: 'LTN7716-P8 — 16-channel NVR, 4 HDD bays, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.ltsecurityinc.com/nvr/embedded-nvr/ltn7716-p16',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '8 MP',
      hddBays: 4,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 200,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      alarmIO: '16-in / 4-out',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'lts-ltn0732-r8',
    manufacturer: 'LTS',
    model: 'LTN0732-R8',
    category: 'nvr-recorder',
    tagline: 'LTN0732-R8 — 32-channel NVR, 8 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.ltsecurityinc.com/nvr/embedded-nvr/ltn0732-r8',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '12 MP',
      hddBays: 8,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: '2U',
      alarmIO: '16-in / 4-out',
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'lts-ltn7616-ht',
    manufacturer: 'LTS',
    model: 'LTN7616-HT',
    category: 'nvr-recorder',
    tagline: 'LTN7616-HT — 16-channel NVR, 4 HDD bays, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.ltsecurityinc.com/nvr/hybrid-nvr-hv/ltn7616-ht',
    specs: {
      channels: 16,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '8 MP',
      hddBays: 4,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'lts-ltn8704-ht',
    manufacturer: 'LTS',
    model: 'LTN8704-HT',
    category: 'nvr-recorder',
    tagline: 'LTN8704-HT — 4-channel NVR, 1 HDD bay, 8 MP',
    verified: false,
    datasheetUrl: 'https://www.ltsecurityinc.com/nvr/hybrid-nvr-hv/ltn8704-ht',
    specs: {
      channels: 4,
      inputBandwidthMbps: 40,
      outputBandwidthMbps: 40,
      maxResolution: '8 MP',
      hddBays: 1,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265+', 'H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'reolink-nvr-rp-pcv8mz',
    manufacturer: 'Reolink',
    model: 'NVR-RP-PCV8MZ',
    category: 'nvr-recorder',
    tagline: 'NVR-RP-PCV8MZ — 8-channel NVR, 2 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://reolink.com/product/nvr-rp-pcv8mz/',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'reolink-nvr-rp-pct12m',
    manufacturer: 'Reolink',
    model: 'NVR-RP-PCT12M',
    category: 'nvr-recorder',
    tagline: 'NVR-RP-PCT12M — 8-channel NVR, 2 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://reolink.com/product/nvr-rp-pcv8mz/',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'reolink-nvr-rp-pct16md',
    manufacturer: 'Reolink',
    model: 'NVR-RP-PCT16MD',
    category: 'nvr-recorder',
    tagline: 'NVR-RP-PCT16MD — 8-channel NVR, 2 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://reolink.com/product/nvr-rp-pcv8mz/',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'reolink-nvr-rlc-843a',
    manufacturer: 'Reolink',
    model: 'NVR-RLC-843A',
    category: 'nvr-recorder',
    tagline: 'NVR-RLC-843A — 8-channel NVR, 2 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://reolink.com/product/nvr-rp-pcv8mz/',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'reolink-nvr-duo-3-poe',
    manufacturer: 'Reolink',
    model: 'NVR-DUO-3-POE',
    category: 'nvr-recorder',
    tagline: 'NVR-DUO-3-POE — 8-channel NVR, 2 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://reolink.com/product/nvr-rp-pcv8mz/',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'reolink-nvr-duo-3v-poe',
    manufacturer: 'Reolink',
    model: 'NVR-DUO-3V-POE',
    category: 'nvr-recorder',
    tagline: 'NVR-DUO-3V-POE — 8-channel NVR, 2 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://reolink.com/product/nvr-rp-pcv8mz/',
    specs: {
      channels: 8,
      inputBandwidthMbps: 80,
      outputBandwidthMbps: 80,
      maxResolution: '12 MP',
      hddBays: 2,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE',
    },
  },
  {
    id: 'tiandy-nvrh264-poe',
    manufacturer: 'Tiandy',
    model: 'NVRH264-POE',
    category: 'nvr-recorder',
    tagline: 'NVRH264-POE — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://en.tiandy.com/product-category/nvr/nvrh264',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'tiandy-nvrh264-poe16ch',
    manufacturer: 'Tiandy',
    model: 'NVRH264-POE16CH',
    category: 'nvr-recorder',
    tagline: 'NVRH264-POE16CH — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://en.tiandy.com/product-category/nvr/nvrh264',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'tiandy-nvrh264-poe4ch',
    manufacturer: 'Tiandy',
    model: 'NVRH264-POE4CH',
    category: 'nvr-recorder',
    tagline: 'NVRH264-POE4CH — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://en.tiandy.com/product-category/nvr/nvrh264',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'tiandy-nvrh264-poe8ch',
    manufacturer: 'Tiandy',
    model: 'NVRH264-POE8CH',
    category: 'nvr-recorder',
    tagline: 'NVRH264-POE8CH — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://en.tiandy.com/product-category/nvr/nvrh264',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'tiandy-nvrh264-standard',
    manufacturer: 'Tiandy',
    model: 'NVRH264-STANDARD',
    category: 'nvr-recorder',
    tagline: 'NVRH264-STANDARD — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://en.tiandy.com/product-category/nvr/nvrh264',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'tiandy-nvrh264-standard16ch',
    manufacturer: 'Tiandy',
    model: 'NVRH264-STANDARD16CH',
    category: 'nvr-recorder',
    tagline: 'NVRH264-STANDARD16CH — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://en.tiandy.com/product-category/nvr/nvrh264',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'tiandy-nvrh264-standard32ch',
    manufacturer: 'Tiandy',
    model: 'NVRH264-STANDARD32CH',
    category: 'nvr-recorder',
    tagline: 'NVRH264-STANDARD32CH — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://en.tiandy.com/product-category/nvr/nvrh264',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'tiandy-nvrh264-standard4ch',
    manufacturer: 'Tiandy',
    model: 'NVRH264-STANDARD4CH',
    category: 'nvr-recorder',
    tagline: 'NVRH264-STANDARD4CH — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://en.tiandy.com/product-category/nvr/nvrh264',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'tiandy-nvrh264-standard8ch',
    manufacturer: 'Tiandy',
    model: 'NVRH264-STANDARD8CH',
    category: 'nvr-recorder',
    tagline: 'NVRH264-STANDARD8CH — 16-channel NVR, 2 HDD bays, 16-port built-in PoE, 8 MP',
    verified: false,
    datasheetUrl: 'https://en.tiandy.com/product-category/nvr/nvrh264',
    specs: {
      channels: 16,
      inputBandwidthMbps: 160,
      outputBandwidthMbps: 160,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 10,
      poeInPorts: 16,
      poeBudgetW: 150,
      codecs: ['H.264'],
      onvif: true,
      formFactor: '1U',
      networkPorts: '1x RJ45 GbE uplink + 16x PoE',
    },
  },
  {
    id: 'tiandy-nvr-dvr-e9-9d-9e-e9-93-b6-e7-99-bd-e8-89-b2dvr',
    manufacturer: 'Tiandy',
    model: 'NVR-DVR%E9%9D%9E%E9%93%B6%E7%99%BD%E8%89%B2DVR',
    category: 'nvr-recorder',
    tagline: 'NVR-DVR%E9%9D%9E%E9%93%B6%E7%99%BD%E8%89%B2DVR — 32-channel NVR, 4 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.tiandy.com/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '12 MP',
      hddBays: 4,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'tiandy-nvr-quick-manual-2',
    manufacturer: 'Tiandy',
    model: 'NVR-QUICK-MANUAL-2',
    category: 'nvr-recorder',
    tagline: 'NVR-QUICK-MANUAL-2 — 32-channel NVR, 4 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.tiandy.com/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '12 MP',
      hddBays: 4,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'tiandy-nvr-2023792',
    manufacturer: 'Tiandy',
    model: 'NVR-2023792',
    category: 'nvr-recorder',
    tagline: 'NVR-2023792 — 32-channel NVR, 4 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.tiandy.com/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '12 MP',
      hddBays: 4,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'tiandy-nvr-264-poe',
    manufacturer: 'Tiandy',
    model: 'NVR-264-POE',
    category: 'nvr-recorder',
    tagline: 'NVR-264-POE — 32-channel NVR, 4 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.tiandy.com/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '12 MP',
      hddBays: 4,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'tiandy-nvr-264-pro',
    manufacturer: 'Tiandy',
    model: 'NVR-264-PRO',
    category: 'nvr-recorder',
    tagline: 'NVR-264-PRO — 32-channel NVR, 4 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.tiandy.com/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '12 MP',
      hddBays: 4,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'tiandy-nvr-264-standard',
    manufacturer: 'Tiandy',
    model: 'NVR-264-STANDARD',
    category: 'nvr-recorder',
    tagline: 'NVR-264-STANDARD — 32-channel NVR, 4 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.tiandy.com/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '12 MP',
      hddBays: 4,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'tiandy-nvr-265',
    manufacturer: 'Tiandy',
    model: 'NVR-265',
    category: 'nvr-recorder',
    tagline: 'NVR-265 — 32-channel NVR, 4 HDD bays, 12 MP',
    verified: false,
    datasheetUrl: 'https://www.tiandy.com/',
    specs: {
      channels: 32,
      inputBandwidthMbps: 256,
      outputBandwidthMbps: 256,
      maxResolution: '12 MP',
      hddBays: 4,
      hddBayMaxTb: 10,
      poeInPorts: 0,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      networkPorts: '2x RJ45 GbE',
    },
  },
  {
    id: 'vstarcam-nvr-network-dvr-emerged-reflecting-high-demand-value-417',
    manufacturer: 'Vstarcam',
    model: 'NVR-NETWORK-DVR-EMERGED-REFLECTING-HIGH-DEMAND-VALUE-417',
    category: 'nvr-recorder',
    tagline: 'NVR-NETWORK-DVR-EMERGED-REFLECTING-HIGH-DEMAND-VALUE-417 — 8-channel NVR, 1 HDD bay, 8-port built-in PoE, 4 MP',
    verified: false,
    datasheetUrl: 'https://www.vstarcam.com/channel/NVR-Network-DVR',
    specs: {
      channels: 8,
      inputBandwidthMbps: 60,
      outputBandwidthMbps: 60,
      maxResolution: '4 MP',
      hddBays: 1,
      hddBayMaxTb: 6,
      poeInPorts: 8,
      poeBudgetW: 80,
      codecs: ['H.265', 'H.264'],
      onvif: true,
      formFactor: 'desktop',
      networkPorts: '1x RJ45 GbE uplink + 8x PoE',
    },
  },
];
